/* eslint-disable react/prop-types */
import React from 'react';

export const Home = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="17.578"
		height="17.578"
		viewBox="0 0 17.578 17.578"
	>
		<g id="My_Home" data-name="My Home" transform="translate(-1 -1)">
			<path
				id="Path_86108"
				data-name="Path 86108"
				d="M20.191,8.99H13.8a.8.8,0,0,1-.8-.8V1.8a.8.8,0,0,1,.8-.8h6.392a.8.8,0,0,1,.8.8V8.191A.8.8,0,0,1,20.191,8.99ZM14.6,7.392h4.794V2.6H14.6Z"
				transform="translate(-2.412)"
				fill={color}
			/>
			<path
				id="Path_86109"
				data-name="Path 86109"
				d="M16.995,20.99a3.995,3.995,0,1,1,3.995-3.995,3.995,3.995,0,0,1-3.995,3.995Zm0-6.392a2.4,2.4,0,1,0,2.4,2.4A2.4,2.4,0,0,0,16.995,14.6Z"
				transform="translate(-2.412 -2.412)"
				fill={color}
			/>
			<path
				id="Path_86110"
				data-name="Path 86110"
				d="M8.191,13H1.8a.8.8,0,0,0-.8.8v6.392a.8.8,0,0,0,.8.8H8.191a.8.8,0,0,0,.8-.8V13.8A.8.8,0,0,0,8.191,13Zm-.8,6.392H2.6V14.6H7.392Z"
				transform="translate(0 -2.412)"
				fill={color}
			/>
			<path
				id="Path_86111"
				data-name="Path 86111"
				d="M8.191,8.99H1.8a.8.8,0,0,1-.8-.8V1.8A.8.8,0,0,1,1.8,1H8.191a.8.8,0,0,1,.8.8V8.191A.8.8,0,0,1,8.191,8.99ZM2.6,7.392H7.392V2.6H2.6Z"
				fill={color}
			/>
		</g>
	</svg>
);

export const Email = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20.364"
		height="16"
		viewBox="0 0 20.364 16"
	>
		<g id="mail_id" data-name="mail id" transform="translate(-288 -705)">
			<path
				id="mail"
				d="M49.818,80H34.545A2.548,2.548,0,0,0,32,82.545V93.455A2.548,2.548,0,0,0,34.545,96H49.818a2.548,2.548,0,0,0,2.545-2.545V82.545A2.548,2.548,0,0,0,49.818,80Zm-.645,4.211L42.628,89.3a.727.727,0,0,1-.893,0L35.19,84.211a.727.727,0,1,1,.893-1.148l6.1,4.744,6.1-4.744a.727.727,0,1,1,.893,1.148Z"
				transform="translate(256 625)"
				fill={color}
			/>
		</g>
	</svg>
);
export const EmailCustom = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="11.262"
		height="11.262"
		viewBox="0 0 20.364 16"
	>
		<g id="mail_id" data-name="mail id" transform="translate(-288 -705)">
			<path
				id="mail"
				d="M49.818,80H34.545A2.548,2.548,0,0,0,32,82.545V93.455A2.548,2.548,0,0,0,34.545,96H49.818a2.548,2.548,0,0,0,2.545-2.545V82.545A2.548,2.548,0,0,0,49.818,80Zm-.645,4.211L42.628,89.3a.727.727,0,0,1-.893,0L35.19,84.211a.727.727,0,1,1,.893-1.148l6.1,4.744,6.1-4.744a.727.727,0,1,1,.893,1.148Z"
				transform="translate(256 625)"
				fill={color}
			/>
		</g>
	</svg>
);

export const CircleAdd = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="61"
		height="61"
		viewBox="0 0 61 61"
	>
		<g
			id="Group_54499"
			data-name="Group 54499"
			transform="translate(195 -4483)"
		>
			<path
				id="Ellipse_44"
				data-name="Ellipse 44"
				d="M30.5,2A28.508,28.508,0,0,0,19.407,56.761,28.508,28.508,0,0,0,41.593,4.239,28.32,28.32,0,0,0,30.5,2m0-2A30.5,30.5,0,1,1,0,30.5,30.5,30.5,0,0,1,30.5,0Z"
				transform="translate(-195 4483)"
				fill={color}
			/>
			<path
				id="Path_86223"
				data-name="Path 86223"
				d="M10.771-4.976v-8.44H2.394v-3.527h8.377v-8.377H14.34v8.377h8.377v3.527H14.34v8.44Z"
				transform="translate(-177 4529)"
				fill={color}
			/>
		</g>
	</svg>
);
export const CircleAddCustom = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		height="25"
		viewBox="0 -960 960 960"
		width="25"
	>
		<path
			d="M453-280h60v-166h167v-60H513v-174h-60v174H280v60h173v166Zm27.266 200q-82.734 0-155.5-31.5t-127.266-86q-54.5-54.5-86-127.341Q80-397.681 80-480.5q0-82.819 31.5-155.659Q143-709 197.5-763t127.341-85.5Q397.681-880 480.5-880q82.819 0 155.659 31.5Q709-817 763-763t85.5 127Q880-563 880-480.266q0 82.734-31.5 155.5T763-197.684q-54 54.316-127 86Q563-80 480.266-80Z"
			fill={color}
		/>
	</svg>
);

export const Profile = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="13.938"
		height="15.68"
		viewBox="0 0 13.938 15.68"
	>
		<g id="My_Profile" data-name="My Profile" transform="translate(-1 -3)">
			<path
				id="Path_86141"
				data-name="Path 86141"
				d="M11.314,12.243a5.227,5.227,0,1,0-6.69,0A6.1,6.1,0,0,0,1,17.809a.871.871,0,0,0,1.742,0A4.356,4.356,0,0,1,7.1,13.453H8.84A4.356,4.356,0,0,1,13.2,17.809a.871.871,0,0,0,1.742,0,6.1,6.1,0,0,0-3.624-5.566Zm-3.345-7.5A3.484,3.484,0,1,1,4.484,8.227,3.484,3.484,0,0,1,7.969,4.742Z"
				fill={color}
			/>
		</g>
	</svg>
);
export const ProfileLayout = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 13.938 15.68"
	>
		<g id="My_Profile" data-name="My Profile" transform="translate(-1 -3)">
			<path
				id="Path_86141"
				data-name="Path 86141"
				d="M11.314,12.243a5.227,5.227,0,1,0-6.69,0A6.1,6.1,0,0,0,1,17.809a.871.871,0,0,0,1.742,0A4.356,4.356,0,0,1,7.1,13.453H8.84A4.356,4.356,0,0,1,13.2,17.809a.871.871,0,0,0,1.742,0,6.1,6.1,0,0,0-3.624-5.566Zm-3.345-7.5A3.484,3.484,0,1,1,4.484,8.227,3.484,3.484,0,0,1,7.969,4.742Z"
				fill={color}
			/>
		</g>
	</svg>
);
export const Expiry = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="15.529"
		height="15.535"
		viewBox="0 0 15.529 15.535"
	>
		<g id="Expiry_" data-name="Expiry " transform="translate(-1.004 -1)">
			<path
				id="Path_86156"
				data-name="Path 86156"
				d="M11.706,12.237a.706.706,0,0,0,.706-.706V8.706a.706.706,0,0,0-1.412,0v2.825A.706.706,0,0,0,11.706,12.237Z"
				transform="translate(-2.937 -2.057)"
				fill={color}
			/>
			<circle
				id="Ellipse_57"
				data-name="Ellipse 57"
				cx="1.059"
				cy="1.059"
				r="1.059"
				transform="translate(7.71 11.578)"
				fill={color}
			/>
			<path
				id="Path_86157"
				data-name="Path 86157"
				d="M16.31,13.47l-5.649-11.3a2.114,2.114,0,0,0-3.785,0L1.227,13.47A2.118,2.118,0,0,0,3.12,16.535h11.3A2.118,2.118,0,0,0,16.31,13.47Zm-1.292,1.313a.706.706,0,0,1-.6.339H3.12A.706.706,0,0,1,2.491,14.1L8.14,2.8A.706.706,0,0,1,9.4,2.8l5.649,11.3a.706.706,0,0,1-.028.685Z"
				transform="translate(0)"
				fill={color}
			/>
		</g>
	</svg>
);
export const RoomType = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14.904"
		height="14.904"
		viewBox="0 0 14.904 14.904"
	>
		<g id="Room_type" data-name="Room type" transform="translate(0)">
			<path
				id="Path_86334"
				data-name="Path 86334"
				d="M12.445,14.9H2.459A2.5,2.5,0,0,1,0,12.415V6.975A2.443,2.443,0,0,1,.82,5.157L5.813.626a2.46,2.46,0,0,1,3.279,0l4.993,4.531a2.419,2.419,0,0,1,.82,1.818v5.44A2.5,2.5,0,0,1,12.445,14.9ZM7.452,1.535a1.2,1.2,0,0,0-.671.224L1.788,6.289a.876.876,0,0,0-.3.76v5.44a1,1,0,0,0,.969.984H12.37a.989.989,0,0,0,.969-.984V7.05a1.414,1.414,0,0,0-.3-.76L8.048,1.759a.846.846,0,0,0-.6-.224Z"
				transform="translate(0 0)"
				fill={color}
			/>
		</g>
	</svg>
);
export const RoomTypeCustom = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="11"
		height="11"
		viewBox="0 0 14.904 14.904"
	>
		<g id="Room_type" data-name="Room type" transform="translate(0)">
			<path
				id="Path_86334"
				data-name="Path 86334"
				d="M12.445,14.9H2.459A2.5,2.5,0,0,1,0,12.415V6.975A2.443,2.443,0,0,1,.82,5.157L5.813.626a2.46,2.46,0,0,1,3.279,0l4.993,4.531a2.419,2.419,0,0,1,.82,1.818v5.44A2.5,2.5,0,0,1,12.445,14.9ZM7.452,1.535a1.2,1.2,0,0,0-.671.224L1.788,6.289a.876.876,0,0,0-.3.76v5.44a1,1,0,0,0,.969.984H12.37a.989.989,0,0,0,.969-.984V7.05a1.414,1.414,0,0,0-.3-.76L8.048,1.759a.846.846,0,0,0-.6-.224Z"
				transform="translate(0 0)"
				fill={color}
			/>
		</g>
	</svg>
);

export const Exclaimation = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="17.432"
		height="17.432"
		viewBox="0 0 17.432 17.432"
	>
		<g id="exclaim" transform="translate(-1 -1)">
			<path
				id="Path_86153"
				data-name="Path 86153"
				d="M11.792,12.131a.792.792,0,0,0,.792-.792V5.792a.792.792,0,0,0-1.585,0v5.547A.792.792,0,0,0,11.792,12.131Z"
				transform="translate(-2.076 -0.831)"
				fill={color}
			/>
			<circle
				id="Ellipse_56"
				data-name="Ellipse 56"
				cx="1.189"
				cy="1.189"
				r="1.189"
				transform="translate(8.527 12.885)"
				fill={color}
			/>
			<path
				id="Path_86154"
				data-name="Path 86154"
				d="M9.716,1a8.716,8.716,0,1,0,8.716,8.716A8.716,8.716,0,0,0,9.716,1Zm0,15.847a7.131,7.131,0,1,1,7.131-7.131,7.131,7.131,0,0,1-7.131,7.131Z"
				fill={color}
			/>
		</g>
	</svg>
);

export const MonthlyRent = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="12.229"
		height="14.949"
		viewBox="0 0 12.229 14.949"
	>
		<g
			id="Monthly_Rent"
			data-name="Monthly Rent"
			transform="translate(-3 -0.998)"
		>
			<path
				id="Path_86146"
				data-name="Path 86146"
				d="M14.937,1.122a.679.679,0,0,0-.625-.082l-1.576.591L11.153,1.04a.713.713,0,0,0-.476,0l-1.563.591L7.538,1.04a.713.713,0,0,0-.476,0l-1.576.591L3.917,1.04A.683.683,0,0,0,3,1.679V15.267a.683.683,0,0,0,.917.639l1.569-.591,1.59.591a.713.713,0,0,0,.476,0l1.563-.591,1.576.591a.713.713,0,0,0,.476,0l1.576-.591,1.576.591a.679.679,0,0,0,.91-.639V1.679A.679.679,0,0,0,14.937,1.122ZM13.87,14.289l-.9-.34a.713.713,0,0,0-.476,0l-1.576.591-1.576-.591a.713.713,0,0,0-.476,0L7.3,14.54l-1.583-.591a.713.713,0,0,0-.476,0l-.883.34V2.657l.89.34a.713.713,0,0,0,.476,0L7.3,2.406,8.87,3a.713.713,0,0,0,.476,0l1.576-.591L12.512,3a.713.713,0,0,0,.476,0l.883-.34Zm-1.359-3.1a.679.679,0,0,1-.679.679H6.4a.679.679,0,1,1,0-1.359h5.435A.679.679,0,0,1,12.512,11.191Zm0-2.718a.679.679,0,0,1-.679.679H6.4a.679.679,0,1,1,0-1.359h5.435A.679.679,0,0,1,12.512,8.473Zm0-2.718a.679.679,0,0,1-.679.679H6.4a.679.679,0,1,1,0-1.359h5.435A.679.679,0,0,1,12.512,5.755Z"
				transform="translate(0 0)"
				fill={color}
			/>
		</g>
	</svg>
);

export const Electricity = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14.642"
		height="22"
		viewBox="0 0 14.642 22"
	>
		<g
			id="Electricity_token"
			data-name="Electricity token"
			transform="translate(-112.969 -628.546)"
		>
			<path
				id="flash"
				d="M46.849,9.068a.92.92,0,0,0-.8-.472h-5.5l.942-7.2a.92.92,0,0,0-1.7-.6l-7.33,11.92a.92.92,0,0,0,.784,1.4h5.412l-.847,7.211a.92.92,0,0,0,1.7.589L46.83,10a.92.92,0,0,0,.019-.931ZM40.123,17.4l.481-4.094a.92.92,0,0,0-.914-1.028h-4.8L39.1,5.426,38.583,9.4a.92.92,0,0,0,.912,1.04H44.4Z"
				transform="translate(80.645 628.189)"
				fill={color}
			/>
		</g>
	</svg>
);

export const Building = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="11.262"
		height="11.262"
		viewBox="0 0 11.262 11.262"
	>
		<g id="Building" transform="translate(-319 -597.869)">
			<path
				id="building-2"
				data-name="building"
				d="M8.757,5.379h.563a.563.563,0,1,0,0-1.126H8.757a.563.563,0,0,0,0,1.126Zm0,2.252h.563a.563.563,0,1,0,0-1.126H8.757a.563.563,0,0,0,0,1.126ZM5.942,5.379H6.5a.563.563,0,1,0,0-1.126H5.942a.563.563,0,1,0,0,1.126Zm0,2.252H6.5A.563.563,0,1,0,6.5,6.5H5.942a.563.563,0,1,0,0,1.126Zm6.757,4.5h-.563V2.563A.563.563,0,0,0,11.573,2H3.689a.563.563,0,0,0-.563.563v9.573H2.563a.563.563,0,0,0,0,1.126H12.7a.563.563,0,0,0,0-1.126Zm-4.5,0H7.068V9.884H8.194Zm2.816,0H9.321V9.321a.563.563,0,0,0-.563-.563H6.5a.563.563,0,0,0-.563.563v2.816H4.252V3.126H11.01Z"
				transform="translate(317 595.869)"
				fill={color}
			/>
		</g>
	</svg>
);

export const DashboardTransation = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24.092"
		height="21.682"
		viewBox="0 0 24.092 21.682"
	>
		<g
			id="Dahboard_transaction"
			data-name="Dahboard transaction"
			transform="translate(-324.909 -378.586)"
		>
			<path
				id="Path_85286"
				data-name="Path 85286"
				d="M190.422,101.029a10.843,10.843,0,1,1,.8,9.137,1.2,1.2,0,1,1,2.085-1.207,8.43,8.43,0,1,0-.825-6.465l2.11-1.2a1.2,1.2,0,0,1,1.195,2.091l-4.216,2.409a1.205,1.205,0,0,1-1.67-.5l-2.409-4.7a1.2,1.2,0,0,1,2.144-1.1Zm11.392,3.216,3.261,3.261a1.2,1.2,0,0,1-1.7,1.7l-3.614-3.614a1.2,1.2,0,0,1-.353-.852V99.926a1.2,1.2,0,1,1,2.409,0Z"
				transform="translate(137.55 284.683)"
				fill={color}
			/>
		</g>
	</svg>
);


export const HamburgerMenuNew = (props:any) => (
	<svg xmlns="http://www.w3.org/2000/svg" {...props} >
    <path d="M128 102.4c0-14.138 11.462-25.6 25.6-25.6h332.8c14.138 0 25.6 11.462 25.6 25.6S500.538 128 486.4 128H153.6c-14.138 0-25.6-11.463-25.6-25.6zm358.4 128H25.6C11.462 230.4 0 241.863 0 256c0 14.138 11.462 25.6 25.6 25.6h460.8c14.138 0 25.6-11.462 25.6-25.6 0-14.137-11.462-25.6-25.6-25.6zm0 153.6H256c-14.137 0-25.6 11.462-25.6 25.6 0 14.137 11.463 25.6 25.6 25.6h230.4c14.138 0 25.6-11.463 25.6-25.6 0-14.138-11.462-25.6-25.6-25.6z" />
  </svg>
  )

export const Calendar = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="15.078"
		height="15.078"
		viewBox="0 0 15.078 15.078"
	>
		<g id="Calendar" transform="translate(-331.258 -430.548)">
			<path
				id="calendar_4_"
				data-name="calendar (4)"
				d="M14.022,16.078H3.056A2.056,2.056,0,0,1,1,14.022v-9.6A2.056,2.056,0,0,1,3.056,2.371h.685V1.685a.685.685,0,1,1,1.371,0v.685H7.854V1.685a.685.685,0,1,1,1.371,0v.685h2.741V1.685a.685.685,0,0,1,1.371,0v.685h.685a2.056,2.056,0,0,1,2.056,2.056v9.6A2.056,2.056,0,0,1,14.022,16.078ZM2.371,7.854v6.168a.685.685,0,0,0,.685.685H14.022a.685.685,0,0,0,.685-.685V7.854Zm0-1.371H14.707V4.427a.685.685,0,0,0-.685-.685h-.685v.685a.685.685,0,0,1-1.371,0V3.741H9.224v.685a.685.685,0,1,1-1.371,0V3.741H5.112v.685a.685.685,0,0,1-1.371,0V3.741H3.056a.685.685,0,0,0-.685.685Z"
				transform="translate(330.258 429.548)"
				fill={color}
			/>
		</g>
	</svg>
);

export const GeneralInfo = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
	>
		<g
			id="General_Information"
			data-name="General Information"
			transform="translate(-287.976 -153.16)"
		>
			<path
				id="information_3_"
				data-name="information (3)"
				d="M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,17.5A7.5,7.5,0,1,1,17.5,10,7.509,7.509,0,0,1,10,17.5ZM11.25,10v4.172a1.25,1.25,0,0,1-2.5,0V10a1.25,1.25,0,0,1,2.5,0Zm0-4.189V6.1a1.25,1.25,0,0,1-2.5,0V5.811a1.25,1.25,0,0,1,2.5,0Z"
				transform="translate(287.976 153.16)"
				fill={color}
			/>
		</g>
	</svg>
);

// export const DashboardTransaction

export const ReferAFriendIcon = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="26.02"
		height="22.754"
		viewBox="0 0 26.02 22.754"
	>
		<g
			id="Refer_a_friend"
			data-name="Refer a friend"
			transform="translate(0 -0.5)"
		>
			<path
				id="Path_86270"
				data-name="Path 86270"
				d="M24.19,118.516a3.211,3.211,0,1,0-4.959-.7,1.688,1.688,0,0,1-.7-.357l-3.3-2.825a1.817,1.817,0,0,0-1.936-.27,1.793,1.793,0,0,0-.292.171,1.8,1.8,0,0,0-2.228.1l-3.3,2.825a1.686,1.686,0,0,1-.7.358,3.212,3.212,0,1,0-4.959.7A4.017,4.017,0,0,0,0,121.892v7.35A.762.762,0,0,0,.762,130H7.294a.762.762,0,0,0,.762-.762v-7l4.7-4.031a2.914,2.914,0,0,0,.251-.244,2.914,2.914,0,0,0,.251.244l4.7,4.031v7a.763.763,0,0,0,.762.762h6.532a.762.762,0,0,0,.762-.762v-7.35A4.016,4.016,0,0,0,24.19,118.516Zm-2.2-4.026a1.687,1.687,0,1,1-1.687,1.687A1.689,1.689,0,0,1,21.992,114.49Zm-17.963,0a1.687,1.687,0,1,1-1.687,1.687A1.689,1.689,0,0,1,4.028,114.49Zm7.739,2.565L6.8,121.314a.762.762,0,0,0-.266.579v6.586H1.525v-6.587a2.5,2.5,0,0,1,2.5-2.5h2.36a3.214,3.214,0,0,0,2.09-.773l3.3-2.825a.287.287,0,0,1,.473.219A1.376,1.376,0,0,1,11.767,117.055ZM24.5,128.479H19.488v-6.586a.762.762,0,0,0-.266-.579l-4.969-4.259a1.376,1.376,0,0,1-.481-1.046.287.287,0,0,1,.474-.218l3.3,2.825a3.214,3.214,0,0,0,2.09.773h2.361a2.5,2.5,0,0,1,2.5,2.5Zm0,0"
				transform="translate(0 -106.749)"
				fill={color}
			/>
			<path
				id="Path_86271"
				data-name="Path 86271"
				d="M241.762,5.291a.762.762,0,0,0,.762-.762V1.262a.762.762,0,1,0-1.525,0V4.528A.762.762,0,0,0,241.762,5.291Zm0,0"
				transform="translate(-228.752)"
				fill={color}
			/>
			<path
				id="Path_86272"
				data-name="Path 86272"
				d="M146.454,51.634a.762.762,0,0,0,1.078-1.078L145.9,48.923A.762.762,0,0,0,144.821,50Zm0,0"
				transform="translate(-137.249 -45.75)"
				fill={color}
			/>
			<path
				id="Path_86273"
				data-name="Path 86273"
				d="M306.028,51.858a.76.76,0,0,0,.539-.223L308.2,50a.762.762,0,0,0-1.078-1.078l-1.633,1.633a.762.762,0,0,0,.539,1.3Zm0,0"
				transform="translate(-289.752 -45.751)"
				fill={color}
			/>
		</g>
	</svg>
);

export const IdentityProof = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22.228"
		height="15.878"
		viewBox="0 0 22.228 15.878"
	>
		<g
			id="Identity_Proof"
			data-name="Identity Proof"
			transform="translate(-3.997 -11.993)"
		>
			<path
				id="path3311"
				d="M7.172,11.993A3.176,3.176,0,0,0,4,15.168V24.7a3.176,3.176,0,0,0,3.175,3.175H23.05A3.176,3.176,0,0,0,26.225,24.7V15.168a3.176,3.176,0,0,0-3.175-3.175Zm0,1.589H23.05a1.588,1.588,0,0,1,1.586,1.586V24.7a1.588,1.588,0,0,1-1.586,1.586H7.172A1.587,1.587,0,0,1,5.586,24.7V15.168a1.587,1.587,0,0,1,1.586-1.586Z"
				fill={color}
			/>
			<path
				id="path3307"
				d="M28.382,18a2.38,2.38,0,1,0,2.38,2.38A2.392,2.392,0,0,0,28.382,18Zm0,1.586a.795.795,0,1,1-.795.795A.783.783,0,0,1,28.382,19.585Z"
				transform="translate(-13.272 -3.622)"
				fill={color}
			/>
			<path
				id="path3303"
				d="M24.76,31A4.778,4.778,0,0,0,20,35.76a.795.795,0,0,0,1.589,0,3.175,3.175,0,1,1,6.35,0,.795.795,0,0,0,1.589,0A4.778,4.778,0,0,0,24.76,31Z"
				transform="translate(-9.649 -11.461)"
				fill={color}
			/>
		</g>
	</svg>
);
export const Documents = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="13.786"
		height="19.863"
		viewBox="0 0 13.786 19.863"
	>
		<g
			id="Important_Documents"
			data-name="Important Documents"
			transform="translate(-59.129 3.666)"
		>
			<path
				id="Path_85671"
				data-name="Path 85671"
				d="M154.976,212h-3.67c-.169,0-.306.231-.306.516s.137.516.306.516h3.67c.169,0,.306-.231.306-.516S155.145,212,154.976,212Z"
				transform="translate(-87.119 -207.024)"
				fill={color}
			/>
			<g id="file_2_" data-name="file (2)" transform="translate(59.129 -3.666)">
				<path
					id="Path_86102"
					data-name="Path 86102"
					d="M7.772,22.163h8.742a2.533,2.533,0,0,0,2.522-2.533V7.1a.735.735,0,0,0-.061-.3.684.684,0,0,0-.092-.143.878.878,0,0,0-.071-.1L15.268,3.015a2.686,2.686,0,0,0-.745-.511h-.051a2.584,2.584,0,0,0-1.021-.2H7.772A2.533,2.533,0,0,0,5.25,4.782V19.63a2.533,2.533,0,0,0,2.522,2.533Zm8.64-15.849h-1.46V4.853ZM6.782,4.782A1.021,1.021,0,0,1,7.8,3.76H13.45V6.3a1.573,1.573,0,0,0,1.562,1.562h2.522V19.63a1.021,1.021,0,0,1-1.021,1.021H7.772A1.021,1.021,0,0,1,6.751,19.63Z"
					transform="translate(-5.25 -2.3)"
					fill={color}
				/>
				<path
					id="Path_86103"
					data-name="Path 86103"
					d="M9.016,17.782h6.127a.766.766,0,0,0,0-1.532H9.016a.766.766,0,0,0,0,1.532Z"
					transform="translate(-5.186 -2.004)"
					fill={color}
				/>
				<path
					id="Path_86104"
					data-name="Path 86104"
					d="M9.016,14.782h6.127a.766.766,0,1,0,0-1.532H9.016a.766.766,0,0,0,0,1.532Z"
					transform="translate(-5.186 -2.068)"
					fill={color}
				/>
				<path
					id="Path_86105"
					data-name="Path 86105"
					d="M9.016,11.782h6.127a.766.766,0,0,0,0-1.532H9.016a.766.766,0,0,0,0,1.532Z"
					transform="translate(-5.186 -2.131)"
					fill={color}
				/>
			</g>
		</g>
	</svg>
);
export const DocumentsLayout = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 13.786 19.863"
	>
		<g
			id="Important_Documents"
			data-name="Important Documents"
			transform="translate(-59.129 3.666)"
		>
			<path
				id="Path_85671"
				data-name="Path 85671"
				d="M154.976,212h-3.67c-.169,0-.306.231-.306.516s.137.516.306.516h3.67c.169,0,.306-.231.306-.516S155.145,212,154.976,212Z"
				transform="translate(-87.119 -207.024)"
				fill={color}
			/>
			<g id="file_2_" data-name="file (2)" transform="translate(59.129 -3.666)">
				<path
					id="Path_86102"
					data-name="Path 86102"
					d="M7.772,22.163h8.742a2.533,2.533,0,0,0,2.522-2.533V7.1a.735.735,0,0,0-.061-.3.684.684,0,0,0-.092-.143.878.878,0,0,0-.071-.1L15.268,3.015a2.686,2.686,0,0,0-.745-.511h-.051a2.584,2.584,0,0,0-1.021-.2H7.772A2.533,2.533,0,0,0,5.25,4.782V19.63a2.533,2.533,0,0,0,2.522,2.533Zm8.64-15.849h-1.46V4.853ZM6.782,4.782A1.021,1.021,0,0,1,7.8,3.76H13.45V6.3a1.573,1.573,0,0,0,1.562,1.562h2.522V19.63a1.021,1.021,0,0,1-1.021,1.021H7.772A1.021,1.021,0,0,1,6.751,19.63Z"
					transform="translate(-5.25 -2.3)"
					fill={color}
				/>
				<path
					id="Path_86103"
					data-name="Path 86103"
					d="M9.016,17.782h6.127a.766.766,0,0,0,0-1.532H9.016a.766.766,0,0,0,0,1.532Z"
					transform="translate(-5.186 -2.004)"
					fill={color}
				/>
				<path
					id="Path_86104"
					data-name="Path 86104"
					d="M9.016,14.782h6.127a.766.766,0,1,0,0-1.532H9.016a.766.766,0,0,0,0,1.532Z"
					transform="translate(-5.186 -2.068)"
					fill={color}
				/>
				<path
					id="Path_86105"
					data-name="Path 86105"
					d="M9.016,11.782h6.127a.766.766,0,0,0,0-1.532H9.016a.766.766,0,0,0,0,1.532Z"
					transform="translate(-5.186 -2.131)"
					fill={color}
				/>
			</g>
		</g>
	</svg>
);

export const Financials = ({ color = '#6e6f71' }) => (
	<svg
		id="Financials"
		xmlns="http://www.w3.org/2000/svg"
		width="18.734"
		height="17.173"
		viewBox="0 0 18.734 17.173"
	>
		<path
			id="Path_85262"
			data-name="Path 85262"
			d="M17.953,8.025h-.781V4.9a.781.781,0,0,0-.781-.781H13.27V1.781A.781.781,0,0,0,12.489,1H2.342A2.344,2.344,0,0,0,0,3.342V15.831a2.344,2.344,0,0,0,2.342,2.342h14.05a.781.781,0,0,0,.781-.781V14.27h.781a.781.781,0,0,0,.781-.781V8.806A.781.781,0,0,0,17.953,8.025ZM2.342,2.561h9.367V4.122H2.342a.781.781,0,1,1,0-1.561Zm13.27,14.05H2.342a.782.782,0,0,1-.781-.781V5.55a2.683,2.683,0,0,0,.781.134h13.27V8.025h-.781a3.122,3.122,0,0,0,0,6.245h.781Zm1.561-3.9H14.831a1.561,1.561,0,1,1,0-3.122h2.342Z"
			transform="translate(0 -1)"
			fill={color}
		/>
		<ellipse
			id="Ellipse_24"
			data-name="Ellipse 24"
			cx="1.274"
			cy="0.849"
			rx="1.274"
			ry="0.849"
			transform="translate(13.58 9.255)"
			fill={color}
		/>
	</svg>
);
export const FinancialsLayout = ({ color = '#6e6f71' }) => (
	<svg
		id="Financials"
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18.734 17.173"
	>
		<path
			id="Path_85262"
			data-name="Path 85262"
			d="M17.953,8.025h-.781V4.9a.781.781,0,0,0-.781-.781H13.27V1.781A.781.781,0,0,0,12.489,1H2.342A2.344,2.344,0,0,0,0,3.342V15.831a2.344,2.344,0,0,0,2.342,2.342h14.05a.781.781,0,0,0,.781-.781V14.27h.781a.781.781,0,0,0,.781-.781V8.806A.781.781,0,0,0,17.953,8.025ZM2.342,2.561h9.367V4.122H2.342a.781.781,0,1,1,0-1.561Zm13.27,14.05H2.342a.782.782,0,0,1-.781-.781V5.55a2.683,2.683,0,0,0,.781.134h13.27V8.025h-.781a3.122,3.122,0,0,0,0,6.245h.781Zm1.561-3.9H14.831a1.561,1.561,0,1,1,0-3.122h2.342Z"
			transform="translate(0 -1)"
			fill={color}
		/>
		<ellipse
			id="Ellipse_24"
			data-name="Ellipse 24"
			cx="1.274"
			cy="0.849"
			rx="1.274"
			ry="0.849"
			transform="translate(13.58 9.255)"
			fill={color}
		/>
	</svg>
);
export const Bookings = ({ color = '6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="19.448"
		height="17.81"
		viewBox="0 0 19.448 17.81"
	>
		<g id="Bookings" transform="translate(0.024 -1)">
			<path
				id="Path_86106"
				data-name="Path 86106"
				d="M10.6,1A8.845,8.845,0,0,0,2.073,7.656l-.593-.9a.809.809,0,1,0-1.35.89l1.781,2.7a.877.877,0,0,0,.513.344.829.829,0,0,0,.612-.117l2.671-1.8a.809.809,0,1,0-.9-1.343l-1.215.819A7.258,7.258,0,1,1,4.706,14.1a.809.809,0,1,0-1.328.925A8.808,8.808,0,0,0,19.423,9.9,8.874,8.874,0,0,0,10.6,1Z"
				transform="translate(0)"
				fill={color}
			/>
			<path
				id="Path_86107"
				data-name="Path 86107"
				d="M12.809,5.95A.809.809,0,0,0,12,6.759v4.088a.842.842,0,0,0,.237.572l2.428,2.45a.82.82,0,0,0,1.145.006.809.809,0,0,0,0-1.145l-2.2-2.216V6.759a.809.809,0,0,0-.809-.809Z"
				transform="translate(-2.291 -0.943)"
				fill={color}
			/>
		</g>
	</svg>
);
export const BookingsLayout = ({ color = '6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 19.448 17.81"
	>
		<g id="Bookings" transform="translate(0.024 -1)">
			<path
				id="Path_86106"
				data-name="Path 86106"
				d="M10.6,1A8.845,8.845,0,0,0,2.073,7.656l-.593-.9a.809.809,0,1,0-1.35.89l1.781,2.7a.877.877,0,0,0,.513.344.829.829,0,0,0,.612-.117l2.671-1.8a.809.809,0,1,0-.9-1.343l-1.215.819A7.258,7.258,0,1,1,4.706,14.1a.809.809,0,1,0-1.328.925A8.808,8.808,0,0,0,19.423,9.9,8.874,8.874,0,0,0,10.6,1Z"
				transform="translate(0)"
				fill={color}
			/>
			<path
				id="Path_86107"
				data-name="Path 86107"
				d="M12.809,5.95A.809.809,0,0,0,12,6.759v4.088a.842.842,0,0,0,.237.572l2.428,2.45a.82.82,0,0,0,1.145.006.809.809,0,0,0,0-1.145l-2.2-2.216V6.759a.809.809,0,0,0-.809-.809Z"
				transform="translate(-2.291 -0.943)"
				fill={color}
			/>
		</g>
	</svg>
);
export const Maintenance = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18.567"
		height="18.567"
		viewBox="0 0 18.567 18.567"
	>
		<g id="Maintenance" transform="translate(-2.058 -2.059)">
			<g
				id="Group_54181"
				data-name="Group 54181"
				transform="translate(2.058 2.059)"
			>
				<path
					id="Path_86098"
					data-name="Path 86098"
					d="M20.092,9.745,19.21,8.483a1.073,1.073,0,0,1-.183-.462L18.8,6.5a2.941,2.941,0,0,0-2.4-2.474l-1.516-.268a1.087,1.087,0,0,1-.456-.2l-1.235-.919a2.943,2.943,0,0,0-3.447-.05l-1.264.883a1.082,1.082,0,0,1-.46.183L6.5,3.882a2.941,2.941,0,0,0-2.474,2.4L3.758,7.8a1.087,1.087,0,0,1-.2.457l-.92,1.235a2.944,2.944,0,0,0-.049,3.448L3.474,14.2a1.073,1.073,0,0,1,.183.462l.224,1.523a2.941,2.941,0,0,0,2.4,2.474l1.516.268a1.087,1.087,0,0,1,.456.2l1.235.919a2.941,2.941,0,0,0,3.448.05l1.263-.883a1.082,1.082,0,0,1,.46-.183l1.524-.224a2.94,2.94,0,0,0,2.473-2.4l.267-1.516a1.075,1.075,0,0,1,.2-.457l.92-1.235a2.941,2.941,0,0,0,.05-3.447Zm-1.547,2.333-.92,1.235a2.965,2.965,0,0,0-.537,1.247l-.267,1.516a1.079,1.079,0,0,1-.907.88l-1.524.224a2.952,2.952,0,0,0-1.261.5l-1.262.882a1.08,1.08,0,0,1-1.262-.019l-1.234-.919a2.96,2.96,0,0,0-1.247-.538l-1.516-.268a1.076,1.076,0,0,1-.879-.906l-.224-1.523a2.967,2.967,0,0,0-.5-1.261l-.882-1.262a1.078,1.078,0,0,1,.018-1.262l.918-1.234A2.965,2.965,0,0,0,5.6,8.125l.267-1.516a1.081,1.081,0,0,1,.908-.881L8.294,5.5A2.952,2.952,0,0,0,9.554,5l1.262-.882a1.076,1.076,0,0,1,1.262.019l1.234.918A2.96,2.96,0,0,0,14.56,5.6l1.516.268a1.076,1.076,0,0,1,.879.906l.224,1.523a2.967,2.967,0,0,0,.5,1.261l.882,1.262a1.078,1.078,0,0,1-.017,1.263Z"
					transform="translate(-2.058 -2.059)"
					fill={color}
				/>
				<path
					id="Path_86099"
					data-name="Path 86099"
					d="M11.42,8a3.42,3.42,0,1,0,3.42,3.42A3.423,3.423,0,0,0,11.42,8Zm0,5.13a1.71,1.71,0,1,1,1.71-1.71A1.712,1.712,0,0,1,11.42,13.13Z"
					transform="translate(-2.136 -2.137)"
					fill={color}
				/>
			</g>
		</g>
	</svg>
);
export const MaintenanceCustom = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="22"
		viewBox="0 0 18.567 18.567"
	>
		<g id="Maintenance" transform="translate(-2.058 -2.059)">
			<g
				id="Group_54181"
				data-name="Group 54181"
				transform="translate(2.058 2.059)"
			>
				<path
					id="Path_86098"
					data-name="Path 86098"
					d="M20.092,9.745,19.21,8.483a1.073,1.073,0,0,1-.183-.462L18.8,6.5a2.941,2.941,0,0,0-2.4-2.474l-1.516-.268a1.087,1.087,0,0,1-.456-.2l-1.235-.919a2.943,2.943,0,0,0-3.447-.05l-1.264.883a1.082,1.082,0,0,1-.46.183L6.5,3.882a2.941,2.941,0,0,0-2.474,2.4L3.758,7.8a1.087,1.087,0,0,1-.2.457l-.92,1.235a2.944,2.944,0,0,0-.049,3.448L3.474,14.2a1.073,1.073,0,0,1,.183.462l.224,1.523a2.941,2.941,0,0,0,2.4,2.474l1.516.268a1.087,1.087,0,0,1,.456.2l1.235.919a2.941,2.941,0,0,0,3.448.05l1.263-.883a1.082,1.082,0,0,1,.46-.183l1.524-.224a2.94,2.94,0,0,0,2.473-2.4l.267-1.516a1.075,1.075,0,0,1,.2-.457l.92-1.235a2.941,2.941,0,0,0,.05-3.447Zm-1.547,2.333-.92,1.235a2.965,2.965,0,0,0-.537,1.247l-.267,1.516a1.079,1.079,0,0,1-.907.88l-1.524.224a2.952,2.952,0,0,0-1.261.5l-1.262.882a1.08,1.08,0,0,1-1.262-.019l-1.234-.919a2.96,2.96,0,0,0-1.247-.538l-1.516-.268a1.076,1.076,0,0,1-.879-.906l-.224-1.523a2.967,2.967,0,0,0-.5-1.261l-.882-1.262a1.078,1.078,0,0,1,.018-1.262l.918-1.234A2.965,2.965,0,0,0,5.6,8.125l.267-1.516a1.081,1.081,0,0,1,.908-.881L8.294,5.5A2.952,2.952,0,0,0,9.554,5l1.262-.882a1.076,1.076,0,0,1,1.262.019l1.234.918A2.96,2.96,0,0,0,14.56,5.6l1.516.268a1.076,1.076,0,0,1,.879.906l.224,1.523a2.967,2.967,0,0,0,.5,1.261l.882,1.262a1.078,1.078,0,0,1-.017,1.263Z"
					transform="translate(-2.058 -2.059)"
					fill={color}
				/>
				<path
					id="Path_86099"
					data-name="Path 86099"
					d="M11.42,8a3.42,3.42,0,1,0,3.42,3.42A3.423,3.423,0,0,0,11.42,8Zm0,5.13a1.71,1.71,0,1,1,1.71-1.71A1.712,1.712,0,0,1,11.42,13.13Z"
					transform="translate(-2.136 -2.137)"
					fill={color}
				/>
			</g>
		</g>
	</svg>
);
export const MaintenanceLayout = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18.567 18.567"
	>
		<g id="Maintenance" transform="translate(-2.058 -2.059)">
			<g
				id="Group_54181"
				data-name="Group 54181"
				transform="translate(2.058 2.059)"
			>
				<path
					id="Path_86098"
					data-name="Path 86098"
					d="M20.092,9.745,19.21,8.483a1.073,1.073,0,0,1-.183-.462L18.8,6.5a2.941,2.941,0,0,0-2.4-2.474l-1.516-.268a1.087,1.087,0,0,1-.456-.2l-1.235-.919a2.943,2.943,0,0,0-3.447-.05l-1.264.883a1.082,1.082,0,0,1-.46.183L6.5,3.882a2.941,2.941,0,0,0-2.474,2.4L3.758,7.8a1.087,1.087,0,0,1-.2.457l-.92,1.235a2.944,2.944,0,0,0-.049,3.448L3.474,14.2a1.073,1.073,0,0,1,.183.462l.224,1.523a2.941,2.941,0,0,0,2.4,2.474l1.516.268a1.087,1.087,0,0,1,.456.2l1.235.919a2.941,2.941,0,0,0,3.448.05l1.263-.883a1.082,1.082,0,0,1,.46-.183l1.524-.224a2.94,2.94,0,0,0,2.473-2.4l.267-1.516a1.075,1.075,0,0,1,.2-.457l.92-1.235a2.941,2.941,0,0,0,.05-3.447Zm-1.547,2.333-.92,1.235a2.965,2.965,0,0,0-.537,1.247l-.267,1.516a1.079,1.079,0,0,1-.907.88l-1.524.224a2.952,2.952,0,0,0-1.261.5l-1.262.882a1.08,1.08,0,0,1-1.262-.019l-1.234-.919a2.96,2.96,0,0,0-1.247-.538l-1.516-.268a1.076,1.076,0,0,1-.879-.906l-.224-1.523a2.967,2.967,0,0,0-.5-1.261l-.882-1.262a1.078,1.078,0,0,1,.018-1.262l.918-1.234A2.965,2.965,0,0,0,5.6,8.125l.267-1.516a1.081,1.081,0,0,1,.908-.881L8.294,5.5A2.952,2.952,0,0,0,9.554,5l1.262-.882a1.076,1.076,0,0,1,1.262.019l1.234.918A2.96,2.96,0,0,0,14.56,5.6l1.516.268a1.076,1.076,0,0,1,.879.906l.224,1.523a2.967,2.967,0,0,0,.5,1.261l.882,1.262a1.078,1.078,0,0,1-.017,1.263Z"
					transform="translate(-2.058 -2.059)"
					fill={color}
				/>
				<path
					id="Path_86099"
					data-name="Path 86099"
					d="M11.42,8a3.42,3.42,0,1,0,3.42,3.42A3.423,3.423,0,0,0,11.42,8Zm0,5.13a1.71,1.71,0,1,1,1.71-1.71A1.712,1.712,0,0,1,11.42,13.13Z"
					transform="translate(-2.136 -2.137)"
					fill={color}
				/>
			</g>
		</g>
	</svg>
);
export const WalletIconNew = ({ color = 'black' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="19.23"
		height="19.23"
		viewBox="0 0 19.23 19.23"
	>
		<path
			id="top-up_1_"
			data-name="top-up (1)"
			d="M4.885,3.923H20.269a.962.962,0,1,0,0-1.923H4.885A2.885,2.885,0,0,0,2,4.885V18.346A2.885,2.885,0,0,0,4.885,21.23H9.692a2.885,2.885,0,0,0,2.885-2.885V13.936l1.243,1.243a.961.961,0,1,0,1.36-1.36l-2.885-2.884a.952.952,0,0,0-.313-.209.962.962,0,0,0-.735,0,.952.952,0,0,0-.313.209L8.049,13.82a.961.961,0,1,0,1.36,1.36l1.245-1.243v4.409a.962.962,0,0,1-.962.962H4.885a.962.962,0,0,1-.962-.962V7.592a2.852,2.852,0,0,0,.962.177H19.307V19.307H15.461a.962.962,0,0,0,0,1.923h4.808a.962.962,0,0,0,.962-.962V6.808a.962.962,0,0,0-.962-.962H4.885a.962.962,0,0,1,0-1.923Z"
			transform="translate(-2 -2)"
			fill={color}
		/>
	</svg>
);
export const Notice = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="12"
		height="18"
		viewBox="0 0 12 17"
	>
		<g id="Notice" transform="translate(-929.291 -547.815)">
			<path
				id="notification-bell"
				d="M3,13.649a.744.744,0,0,0,.744.744H6.72a2.976,2.976,0,1,0,5.952,0h2.976a.744.744,0,1,0,0-1.488h-.137a2.206,2.206,0,0,0,.137-.744V8.44a5.957,5.957,0,0,0-4.464-5.756v-.2a1.488,1.488,0,1,0-2.976,0v.2A5.957,5.957,0,0,0,3.744,8.44v3.72a2.206,2.206,0,0,0,.137.744H3.744A.744.744,0,0,0,3,13.649Zm6.7,2.232a1.49,1.49,0,0,1-1.488-1.488h2.976A1.49,1.49,0,0,1,9.7,15.881Zm-4.464-3.72V8.44a4.464,4.464,0,0,1,8.928,0v3.72a.745.745,0,0,1-.744.744H5.976A.745.745,0,0,1,5.232,12.161Z"
				transform="translate(926.291 546.815)"
				fill={color}
			/>
		</g>
	</svg>
);
export const NoticeCustom = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="22"
		viewBox="0 0 12 17"
	>
		<g id="Notice" transform="translate(-929.291 -547.815)">
			<path
				id="notification-bell"
				d="M3,13.649a.744.744,0,0,0,.744.744H6.72a2.976,2.976,0,1,0,5.952,0h2.976a.744.744,0,1,0,0-1.488h-.137a2.206,2.206,0,0,0,.137-.744V8.44a5.957,5.957,0,0,0-4.464-5.756v-.2a1.488,1.488,0,1,0-2.976,0v.2A5.957,5.957,0,0,0,3.744,8.44v3.72a2.206,2.206,0,0,0,.137.744H3.744A.744.744,0,0,0,3,13.649Zm6.7,2.232a1.49,1.49,0,0,1-1.488-1.488h2.976A1.49,1.49,0,0,1,9.7,15.881Zm-4.464-3.72V8.44a4.464,4.464,0,0,1,8.928,0v3.72a.745.745,0,0,1-.744.744H5.976A.745.745,0,0,1,5.232,12.161Z"
				transform="translate(926.291 546.815)"
				fill={color}
			/>
		</g>
	</svg>
);
export const NoticeMobile = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 13.938 15.68"
	>
		<g id="Notice" transform="translate(-929.291 -547.815)">
			<path
				id="notification-bell"
				d="M3,13.649a.744.744,0,0,0,.744.744H6.72a2.976,2.976,0,1,0,5.952,0h2.976a.744.744,0,1,0,0-1.488h-.137a2.206,2.206,0,0,0,.137-.744V8.44a5.957,5.957,0,0,0-4.464-5.756v-.2a1.488,1.488,0,1,0-2.976,0v.2A5.957,5.957,0,0,0,3.744,8.44v3.72a2.206,2.206,0,0,0,.137.744H3.744A.744.744,0,0,0,3,13.649Zm6.7,2.232a1.49,1.49,0,0,1-1.488-1.488h2.976A1.49,1.49,0,0,1,9.7,15.881Zm-4.464-3.72V8.44a4.464,4.464,0,0,1,8.928,0v3.72a.745.745,0,0,1-.744.744H5.976A.745.745,0,0,1,5.232,12.161Z"
				transform="translate(926.291 546.815)"
				fill={color}
			/>
		</g>
	</svg>
);
export const NoticeLayout = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 12 17"
	>
		<g id="Notice" transform="translate(-929.291 -547.815)">
			<path
				id="notification-bell"
				d="M3,13.649a.744.744,0,0,0,.744.744H6.72a2.976,2.976,0,1,0,5.952,0h2.976a.744.744,0,1,0,0-1.488h-.137a2.206,2.206,0,0,0,.137-.744V8.44a5.957,5.957,0,0,0-4.464-5.756v-.2a1.488,1.488,0,1,0-2.976,0v.2A5.957,5.957,0,0,0,3.744,8.44v3.72a2.206,2.206,0,0,0,.137.744H3.744A.744.744,0,0,0,3,13.649Zm6.7,2.232a1.49,1.49,0,0,1-1.488-1.488h2.976A1.49,1.49,0,0,1,9.7,15.881Zm-4.464-3.72V8.44a4.464,4.464,0,0,1,8.928,0v3.72a.745.745,0,0,1-.744.744H5.976A.745.745,0,0,1,5.232,12.161Z"
				transform="translate(926.291 546.815)"
				fill={color}
			/>
		</g>
	</svg>
);

export const NoticeNotification = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 12 17"
	>
		<g id="Notice" transform="translate(-929.291 -547.815)">
			<path
				id="notification-bell"
				d="M3,13.649a.744.744,0,0,0,.744.744H6.72a2.976,2.976,0,1,0,5.952,0h2.976a.744.744,0,1,0,0-1.488h-.137a2.206,2.206,0,0,0,.137-.744V8.44a5.957,5.957,0,0,0-4.464-5.756v-.2a1.488,1.488,0,1,0-2.976,0v.2A5.957,5.957,0,0,0,3.744,8.44v3.72a2.206,2.206,0,0,0,.137.744H3.744A.744.744,0,0,0,3,13.649Zm6.7,2.232a1.49,1.49,0,0,1-1.488-1.488h2.976A1.49,1.49,0,0,1,9.7,15.881Zm-4.464-3.72V8.44a4.464,4.464,0,0,1,8.928,0v3.72a.745.745,0,0,1-.744.744H5.976A.745.745,0,0,1,5.232,12.161Z"
				transform="translate(926.291 546.815)"
				fill={color}
			/>
		</g>
	</svg>
);

export const KnowYourCommunity = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21.808"
		height="19.048"
		viewBox="0 0 21.808 19.048"
	>
		<g
			id="Know_your_Community"
			data-name="Know your Community"
			transform="translate(-927.073 -608.451)"
		>
			<path
				id="partnership_1_"
				data-name="partnership (1)"
				d="M16.1.689a.639.639,0,0,0-.907,0l-1.887,1.9a.654.654,0,0,1-.467.2h-3.9a.655.655,0,0,1-.468-.2L6.614.73A.639.639,0,0,0,6.161.543h0a.639.639,0,0,0-.453.189L.186,6.294a.639.639,0,0,0,0,.9L1.771,8.782a1.6,1.6,0,0,1,.465,1.133,2.869,2.869,0,0,0,.444,1.54A1.961,1.961,0,0,0,2.8,14.073a1.921,1.921,0,0,0,1.277.571,1.946,1.946,0,0,0,.563,1.284,1.921,1.921,0,0,0,1.277.571,1.941,1.941,0,0,0,2.591,1.743,1.937,1.937,0,0,0,3.2.734l.27-.272a1.94,1.94,0,0,0,.392-.571A1.939,1.939,0,0,0,15.6,16.76a1.921,1.921,0,0,0,1.277-.571,1.946,1.946,0,0,0,.563-1.284,1.921,1.921,0,0,0,1.277-.57,1.961,1.961,0,0,0,.133-2.606,3.76,3.76,0,0,0,.694-2.186.714.714,0,0,1,.2-.5l1.878-1.893a.639.639,0,0,0,0-.9ZM3.71,12.219l.92-.927a.655.655,0,0,1,.934,0,.678.678,0,0,1,0,.954l-.92.927a.655.655,0,0,1-.934,0A.679.679,0,0,1,3.71,12.219Zm1.841,1.854,1.84-1.854a.656.656,0,0,1,.934,0,.679.679,0,0,1,0,.954L6.484,15.027a.655.655,0,0,1-.934,0A.679.679,0,0,1,5.551,14.073Zm1.84,2.808a.679.679,0,0,1,0-.954L8.311,15a.656.656,0,0,1,.934,0,.679.679,0,0,1,.055.891c-.056.052.027-.032-.975.99A.655.655,0,0,1,7.391,16.881Zm3.689.922-.27.272a.655.655,0,0,1-.934,0,.678.678,0,0,1-.063-.88c.351-.355.334-.334.395-.4a.654.654,0,0,1,.871.055A.679.679,0,0,1,11.08,17.8Zm6.726-4.367a.656.656,0,0,1-.934,0l-1.19-1.2a.639.639,0,0,0-.907.9l1.19,1.2a.679.679,0,0,1,0,.954.655.655,0,0,1-.934,0l-1.19-1.2a.639.639,0,0,0-.907.9l1.19,1.2a.678.678,0,0,1,0,.954.655.655,0,0,1-.934,0,14.09,14.09,0,0,0-1.319-1.3,1.916,1.916,0,0,0-1.158-.465,1.947,1.947,0,0,0-1.182-1.7,1.962,1.962,0,0,0-.3-2.361,1.933,1.933,0,0,0-2.348-.31,1.936,1.936,0,0,0-3.16-.617l-.1.1a1.611,1.611,0,0,1-.107-.58A2.868,2.868,0,0,0,2.677,7.88L1.541,6.743,6.162,2.087l1.4,1.4A1.921,1.921,0,0,0,8.71,4.05L5.855,7.476a.639.639,0,0,0,.082.9,3.194,3.194,0,0,0,4.5-.41.777.777,0,0,1,.936-.2,3.717,3.717,0,0,0,2.094.343l4.341,4.373A.679.679,0,0,1,17.806,13.435Zm1.032-5.291a1.974,1.974,0,0,0-.576,1.4,2.5,2.5,0,0,1-.332,1.249l-3.107-3.13a3.755,3.755,0,0,0,1.5-1.543.639.639,0,0,0-1.132-.594,2.481,2.481,0,0,1-1.609,1.265.623.623,0,0,0-.087.019,2.453,2.453,0,0,1-1.57-.2,2.053,2.053,0,0,0-2.474.535,1.92,1.92,0,0,1-2.139.571l2.958-3.55a2.451,2.451,0,0,1,.714-.112h1.854a1.918,1.918,0,0,0,1.374-.567l1.434-1.445L20.27,6.7Zm0,0"
				transform="translate(927.072 607.951)"
				fill={color}
			/>
		</g>
	</svg>
);
export const KnowYourCommunityLayout = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 21.808 19.048"
	>
		<g
			id="Know_your_Community"
			data-name="Know your Community"
			transform="translate(-927.073 -608.451)"
		>
			<path
				id="partnership_1_"
				data-name="partnership (1)"
				d="M16.1.689a.639.639,0,0,0-.907,0l-1.887,1.9a.654.654,0,0,1-.467.2h-3.9a.655.655,0,0,1-.468-.2L6.614.73A.639.639,0,0,0,6.161.543h0a.639.639,0,0,0-.453.189L.186,6.294a.639.639,0,0,0,0,.9L1.771,8.782a1.6,1.6,0,0,1,.465,1.133,2.869,2.869,0,0,0,.444,1.54A1.961,1.961,0,0,0,2.8,14.073a1.921,1.921,0,0,0,1.277.571,1.946,1.946,0,0,0,.563,1.284,1.921,1.921,0,0,0,1.277.571,1.941,1.941,0,0,0,2.591,1.743,1.937,1.937,0,0,0,3.2.734l.27-.272a1.94,1.94,0,0,0,.392-.571A1.939,1.939,0,0,0,15.6,16.76a1.921,1.921,0,0,0,1.277-.571,1.946,1.946,0,0,0,.563-1.284,1.921,1.921,0,0,0,1.277-.57,1.961,1.961,0,0,0,.133-2.606,3.76,3.76,0,0,0,.694-2.186.714.714,0,0,1,.2-.5l1.878-1.893a.639.639,0,0,0,0-.9ZM3.71,12.219l.92-.927a.655.655,0,0,1,.934,0,.678.678,0,0,1,0,.954l-.92.927a.655.655,0,0,1-.934,0A.679.679,0,0,1,3.71,12.219Zm1.841,1.854,1.84-1.854a.656.656,0,0,1,.934,0,.679.679,0,0,1,0,.954L6.484,15.027a.655.655,0,0,1-.934,0A.679.679,0,0,1,5.551,14.073Zm1.84,2.808a.679.679,0,0,1,0-.954L8.311,15a.656.656,0,0,1,.934,0,.679.679,0,0,1,.055.891c-.056.052.027-.032-.975.99A.655.655,0,0,1,7.391,16.881Zm3.689.922-.27.272a.655.655,0,0,1-.934,0,.678.678,0,0,1-.063-.88c.351-.355.334-.334.395-.4a.654.654,0,0,1,.871.055A.679.679,0,0,1,11.08,17.8Zm6.726-4.367a.656.656,0,0,1-.934,0l-1.19-1.2a.639.639,0,0,0-.907.9l1.19,1.2a.679.679,0,0,1,0,.954.655.655,0,0,1-.934,0l-1.19-1.2a.639.639,0,0,0-.907.9l1.19,1.2a.678.678,0,0,1,0,.954.655.655,0,0,1-.934,0,14.09,14.09,0,0,0-1.319-1.3,1.916,1.916,0,0,0-1.158-.465,1.947,1.947,0,0,0-1.182-1.7,1.962,1.962,0,0,0-.3-2.361,1.933,1.933,0,0,0-2.348-.31,1.936,1.936,0,0,0-3.16-.617l-.1.1a1.611,1.611,0,0,1-.107-.58A2.868,2.868,0,0,0,2.677,7.88L1.541,6.743,6.162,2.087l1.4,1.4A1.921,1.921,0,0,0,8.71,4.05L5.855,7.476a.639.639,0,0,0,.082.9,3.194,3.194,0,0,0,4.5-.41.777.777,0,0,1,.936-.2,3.717,3.717,0,0,0,2.094.343l4.341,4.373A.679.679,0,0,1,17.806,13.435Zm1.032-5.291a1.974,1.974,0,0,0-.576,1.4,2.5,2.5,0,0,1-.332,1.249l-3.107-3.13a3.755,3.755,0,0,0,1.5-1.543.639.639,0,0,0-1.132-.594,2.481,2.481,0,0,1-1.609,1.265.623.623,0,0,0-.087.019,2.453,2.453,0,0,1-1.57-.2,2.053,2.053,0,0,0-2.474.535,1.92,1.92,0,0,1-2.139.571l2.958-3.55a2.451,2.451,0,0,1,.714-.112h1.854a1.918,1.918,0,0,0,1.374-.567l1.434-1.445L20.27,6.7Zm0,0"
				transform="translate(927.072 607.951)"
				fill={color}
			/>
		</g>
	</svg>
);

export const VisitorDetailsTwo = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 22.578 18.062"
	>
		<g
			id="Visitors_Details"
			data-name="Visitors Details"
			transform="translate(-1 -4)"
		>
			<path
				id="Path_86204"
				data-name="Path 86204"
				d="M20.8,4H3.776A2.779,2.779,0,0,0,1,6.776v12.51a2.779,2.779,0,0,0,2.776,2.776H20.8a2.779,2.779,0,0,0,2.776-2.776V6.776A2.779,2.779,0,0,0,20.8,4Zm1.271,15.286A1.273,1.273,0,0,1,20.8,20.557H3.776a1.273,1.273,0,0,1-1.271-1.271V6.776A1.273,1.273,0,0,1,3.776,5.505H20.8a1.273,1.273,0,0,1,1.271,1.271Z"
				fill={color}
			/>
			<path
				id="Path_86205"
				data-name="Path 86205"
				d="M10.01,14.021A3.01,3.01,0,1,0,7,11.01a3.01,3.01,0,0,0,3.01,3.01Zm0-4.516A1.505,1.505,0,1,1,8.505,11.01,1.505,1.505,0,0,1,10.01,9.505Z"
				transform="translate(-1.484 -0.99)"
				fill={color}
			/>
			<path
				id="Path_86206"
				data-name="Path 86206"
				d="M9.516,17A4.52,4.52,0,0,0,5,21.516a.753.753,0,0,0,1.505,0,3.01,3.01,0,1,1,6.021,0,.753.753,0,0,0,1.505,0A4.52,4.52,0,0,0,9.516,17Z"
				transform="translate(-0.99 -3.216)"
				fill={color}
			/>
			<path
				id="Path_86207"
				data-name="Path 86207"
				d="M24.268,15H19.753a.753.753,0,1,0,0,1.505h4.516a.753.753,0,1,0,0-1.505Z"
				transform="translate(-4.453 -2.721)"
				fill={color}
			/>
			<path
				id="Path_86208"
				data-name="Path 86208"
				d="M24.268,20H19.753a.753.753,0,1,0,0,1.505h4.516a.753.753,0,1,0,0-1.505Z"
				transform="translate(-4.453 -3.958)"
				fill={color}
			/>
			<path
				id="Path_86209"
				data-name="Path 86209"
				d="M24.268,10H19.753a.753.753,0,0,0,0,1.505h4.516a.753.753,0,0,0,0-1.505Z"
				transform="translate(-4.453 -1.484)"
				fill={color}
			/>
		</g>
	</svg>
);
export const VisitorDetails = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22.578"
		height="18.062"
		viewBox="0 0 22.578 18.062"
	>
		<g
			id="Visitors_Details"
			data-name="Visitors Details"
			transform="translate(-1 -4)"
		>
			<path
				id="Path_86204"
				data-name="Path 86204"
				d="M20.8,4H3.776A2.779,2.779,0,0,0,1,6.776v12.51a2.779,2.779,0,0,0,2.776,2.776H20.8a2.779,2.779,0,0,0,2.776-2.776V6.776A2.779,2.779,0,0,0,20.8,4Zm1.271,15.286A1.273,1.273,0,0,1,20.8,20.557H3.776a1.273,1.273,0,0,1-1.271-1.271V6.776A1.273,1.273,0,0,1,3.776,5.505H20.8a1.273,1.273,0,0,1,1.271,1.271Z"
				fill={color}
			/>
			<path
				id="Path_86205"
				data-name="Path 86205"
				d="M10.01,14.021A3.01,3.01,0,1,0,7,11.01a3.01,3.01,0,0,0,3.01,3.01Zm0-4.516A1.505,1.505,0,1,1,8.505,11.01,1.505,1.505,0,0,1,10.01,9.505Z"
				transform="translate(-1.484 -0.99)"
				fill={color}
			/>
			<path
				id="Path_86206"
				data-name="Path 86206"
				d="M9.516,17A4.52,4.52,0,0,0,5,21.516a.753.753,0,0,0,1.505,0,3.01,3.01,0,1,1,6.021,0,.753.753,0,0,0,1.505,0A4.52,4.52,0,0,0,9.516,17Z"
				transform="translate(-0.99 -3.216)"
				fill={color}
			/>
			<path
				id="Path_86207"
				data-name="Path 86207"
				d="M24.268,15H19.753a.753.753,0,1,0,0,1.505h4.516a.753.753,0,1,0,0-1.505Z"
				transform="translate(-4.453 -2.721)"
				fill={color}
			/>
			<path
				id="Path_86208"
				data-name="Path 86208"
				d="M24.268,20H19.753a.753.753,0,1,0,0,1.505h4.516a.753.753,0,1,0,0-1.505Z"
				transform="translate(-4.453 -3.958)"
				fill={color}
			/>
			<path
				id="Path_86209"
				data-name="Path 86209"
				d="M24.268,10H19.753a.753.753,0,0,0,0,1.505h4.516a.753.753,0,0,0,0-1.505Z"
				transform="translate(-4.453 -1.484)"
				fill={color}
			/>
		</g>
	</svg>
);

export const ElectricityToken = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14.642"
		height="22"
		viewBox="0 0 14.642 22"
	>
		<g
			id="Electricity_token"
			data-name="Electricity token"
			transform="translate(-112.969 -628.546)"
		>
			<path
				id="flash"
				d="M46.849,9.068a.92.92,0,0,0-.8-.472h-5.5l.942-7.2a.92.92,0,0,0-1.7-.6l-7.33,11.92a.92.92,0,0,0,.784,1.4h5.412l-.847,7.211a.92.92,0,0,0,1.7.589L46.83,10a.92.92,0,0,0,.019-.931ZM40.123,17.4l.481-4.094a.92.92,0,0,0-.914-1.028h-4.8L39.1,5.426,38.583,9.4a.92.92,0,0,0,.912,1.04H44.4Z"
				transform="translate(80.645 628.189)"
				fill={color}
			/>
		</g>
	</svg>
);
export const ElectricityTokenLayout = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 14.642 22"
	>
		<g
			id="Electricity_token"
			data-name="Electricity token"
			transform="translate(-112.969 -628.546)"
		>
			<path
				id="flash"
				d="M46.849,9.068a.92.92,0,0,0-.8-.472h-5.5l.942-7.2a.92.92,0,0,0-1.7-.6l-7.33,11.92a.92.92,0,0,0,.784,1.4h5.412l-.847,7.211a.92.92,0,0,0,1.7.589L46.83,10a.92.92,0,0,0,.019-.931ZM40.123,17.4l.481-4.094a.92.92,0,0,0-.914-1.028h-4.8L39.1,5.426,38.583,9.4a.92.92,0,0,0,.912,1.04H44.4Z"
				transform="translate(80.645 628.189)"
				fill={color}
			/>
		</g>
	</svg>
);

export const UploadFile = ({ color = '#65BCB0' }) => (
	<svg
		id="Upload_file"
		data-name="Upload file"
		xmlns="http://www.w3.org/2000/svg"
		width="13.786"
		height="19.863"
		viewBox="0 0 13.786 19.863"
	>
		<path
			id="Path_86102"
			data-name="Path 86102"
			d="M7.772,22.163h8.742a2.533,2.533,0,0,0,2.522-2.533V7.1a.735.735,0,0,0-.061-.3.684.684,0,0,0-.092-.143.878.878,0,0,0-.071-.1L15.268,3.015a2.686,2.686,0,0,0-.745-.511h-.051a2.584,2.584,0,0,0-1.021-.2H7.772A2.533,2.533,0,0,0,5.25,4.782V19.63a2.533,2.533,0,0,0,2.522,2.533Zm8.64-15.849h-1.46V4.853ZM6.782,4.782A1.021,1.021,0,0,1,7.8,3.76H13.45V6.3a1.573,1.573,0,0,0,1.562,1.562h2.522V19.63a1.021,1.021,0,0,1-1.021,1.021H7.772A1.021,1.021,0,0,1,6.751,19.63Z"
			transform="translate(-5.25 -2.3)"
			fill={color}
		/>
		<path
			id="Path_86103"
			data-name="Path 86103"
			d="M9.016,17.782h6.127a.766.766,0,0,0,0-1.532H9.016a.766.766,0,0,0,0,1.532Z"
			transform="translate(-5.186 -2.004)"
			fill={color}
		/>
		<path
			id="Path_86104"
			data-name="Path 86104"
			d="M9.016,14.782h6.127a.766.766,0,1,0,0-1.532H9.016a.766.766,0,0,0,0,1.532Z"
			transform="translate(-5.186 -2.068)"
			fill={color}
		/>
		<path
			id="Path_86105"
			data-name="Path 86105"
			d="M9.016,11.782h6.127a.766.766,0,0,0,0-1.532H9.016a.766.766,0,0,0,0,1.532Z"
			transform="translate(-5.186 -2.131)"
			fill={color}
		/>
	</svg>
);

// export const editIcon=({color=""})=>(
// 	<svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
// 		<path d="m39.7 14.7-6.4-6.4 2.1-2.1q.85-.85 2.125-.825 1.275.025 2.125.875L41.8 8.4q.85.85.85 2.1t-.85 2.1Zm-2.1 2.1L12.4 42H6v-6.4l25.2-25.2Z"/>
// 		</svg>
// )

export const Sports = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20.42"
		height="20.42"
		viewBox="0 0 20.42 20.42"
	>
		<g id="Sports" transform="translate(-287.909 -581.057)">
			<path
				id="stadium_1_"
				data-name="stadium (1)"
				d="M19.782,7.657H17.229V6.742L20.11,5.014a.638.638,0,0,0,0-1.094L16.919,2.005C16.912,2,16.9,2,16.9,2a.624.624,0,0,0-.108-.047l-.042-.013a.661.661,0,0,0-.126-.018l-.025,0h0a.617.617,0,0,0-.145.018.389.389,0,0,0-.038.012.63.63,0,0,0-.109.044c-.007,0-.015.005-.022.009s-.009.008-.015.011a.655.655,0,0,0-.115.087l-.006.005a.636.636,0,0,0-.091.118c-.007.012-.013.024-.02.037a.617.617,0,0,0-.044.105c0,.013-.009.026-.012.04a.635.635,0,0,0-.02.152v5.1h-5.1V4.828L13.729,3.1a.638.638,0,0,0,0-1.094L10.538.091c-.007,0-.016-.006-.023-.01a.675.675,0,0,0-.107-.047L10.364.02A.691.691,0,0,0,10.242,0l-.029,0h0a.614.614,0,0,0-.145.018.4.4,0,0,0-.038.012.658.658,0,0,0-.109.044C9.911.078,9.9.079,9.9.083s-.009.008-.015.011a.655.655,0,0,0-.115.087L9.76.186A.642.642,0,0,0,9.667.3c-.007.012-.013.024-.02.037A.629.629,0,0,0,9.6.445c0,.013-.009.026-.012.04a.638.638,0,0,0-.019.153V7.657h-5.1V6.742L7.348,5.014a.638.638,0,0,0,0-1.094L4.157,2.005C4.15,2,4.141,2,4.134,2a.624.624,0,0,0-.108-.047l-.042-.013a.653.653,0,0,0-.128-.018l-.025,0h0a.617.617,0,0,0-.145.018.389.389,0,0,0-.038.012.63.63,0,0,0-.109.044c-.007,0-.015.005-.022.009s-.009.008-.015.011a.655.655,0,0,0-.115.087L3.378,2.1a.649.649,0,0,0-.091.118c-.007.012-.013.024-.02.037a.617.617,0,0,0-.044.105c0,.013-.009.026-.012.04a.635.635,0,0,0-.02.152v5.1H.638A.638.638,0,0,0,0,8.3v3.829a.646.646,0,0,0,.013.131v0a.626.626,0,0,0,.048.138s0,.01.005.015.443.893.792,1.848a5.41,5.41,0,0,1,.418,1.7v3.829a.638.638,0,0,0,.638.638H18.505a.638.638,0,0,0,.638-.638V15.953a5.41,5.41,0,0,1,.417-1.7c.349-.957.787-1.839.792-1.848s0-.01.005-.015a.637.637,0,0,0,.048-.137v0a.621.621,0,0,0,.014-.13V8.3A.638.638,0,0,0,19.782,7.657Zm-2.552-2.4V3.679l1.312.787ZM10.848,3.34V1.765l1.312.787ZM4.467,5.254V3.679l1.312.787ZM18.521,13.4H1.9c-.09-.228-.18-.444-.265-.638H18.786C18.7,12.957,18.611,13.172,18.521,13.4ZM1.276,11.486v-.638H19.144v.638Zm0-2.552H19.144v.638H1.276Zm7.657,10.21V16.591h2.552v2.552Zm8.934-3.191v3.191h-5.1V15.953a.638.638,0,0,0-.638-.638H8.3a.638.638,0,0,0-.638.638v3.191h-5.1V15.953a4.836,4.836,0,0,0-.214-1.276H18.081A4.836,4.836,0,0,0,17.867,15.953Zm0,0"
				transform="translate(287.909 581.057)"
				fill={color}
			/>
		</g>
	</svg>
);

export const Arts = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18.103"
		height="18.103"
		viewBox="0 0 18.103 18.103"
	>
		<g id="Arts" transform="translate(-287.909 -623.841)">
			<path
				id="fine-arts"
				d="M13.927,3.175a1.718,1.718,0,0,1,.3-2.027C15,.386,16.4.49,17.454.037A.465.465,0,0,1,18.1.509a5.278,5.278,0,0,1-1.164,3.238,1.744,1.744,0,0,1-1.273.495,2,2,0,0,1-.668-.135l-9.12,9.121a.707.707,0,0,1-1-1Zm3.524,2.537a.707.707,0,0,0-1.313.525,7.549,7.549,0,0,1,.551,2.813c0,1.276-.865,1.414-1.237,1.414a2.117,2.117,0,0,1-1.136-.312,3.472,3.472,0,0,0-1.763-.465,3.028,3.028,0,0,0-2.14.837,2.948,2.948,0,0,0-.866,2.133,3.031,3.031,0,0,0,.524,1.752,1.686,1.686,0,0,1,.325,1.041,1.364,1.364,0,0,1-.258.837,1.324,1.324,0,0,1-1.085.4,7.637,7.637,0,1,1,0-15.274,7.7,7.7,0,0,1,2.525.456A.707.707,0,0,0,12.042.533,9.107,9.107,0,0,0,9.051,0a9.051,9.051,0,0,0-6.4,15.452,8.992,8.992,0,0,0,6.4,2.651,2.656,2.656,0,0,0,2.185-.926,2.744,2.744,0,0,0,.572-1.726,3.06,3.06,0,0,0-.528-1.772,1.659,1.659,0,0,1-.32-1.021A1.506,1.506,0,0,1,12.552,11.1a2.085,2.085,0,0,1,1.116.309,3.506,3.506,0,0,0,1.783.469,2.7,2.7,0,0,0,1.741-.62A2.76,2.76,0,0,0,18.1,9.05,8.957,8.957,0,0,0,17.451,5.712ZM2.829,9.3A1.061,1.061,0,1,0,3.889,8.237,1.062,1.062,0,0,0,2.829,9.3Zm7.213-5.41A1.061,1.061,0,1,0,8.981,4.949,1.062,1.062,0,0,0,10.041,3.888ZM5.983,6.336a1.062,1.062,0,0,0,0-1.5h0a1.061,1.061,0,1,0,0,1.5Z"
				transform="translate(287.909 623.842)"
				fill={color}
			/>
		</g>
	</svg>
);

export const Refunds = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16.206"
		height="17.695"
		viewBox="0 0 16.206 17.695"
	>
		<g id="Refund" transform="translate(-330.926 -86)">
			<g id="Icon" transform="translate(328.903 84.527)">
				<path
					id="Path_86264"
					data-name="Path 86264"
					d="M2.124,14.177A8.474,8.474,0,1,0,3.6,4.68a1.017,1.017,0,1,0,1.478,1.4,6.437,6.437,0,1,1-1.122,7.216,1.017,1.017,0,0,0-1.831.884Z"
					transform="translate(0 0.197)"
					fill={color}
				/>
				<path
					id="Path_86265"
					data-name="Path 86265"
					d="M2.838,2.437l-.2,3.829A1.017,1.017,0,0,0,3.6,7.334l3.829.2a1.017,1.017,0,1,0,.1-2.031L4.724,5.357l.145-2.814a1.017,1.017,0,0,0-2.031-.106Z"
					transform="translate(0.219 0)"
					fill={color}
				/>
			</g>
		</g>
	</svg>
);

export const QuestionMarkIcon = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20.91"
		height="20.91"
		viewBox="0 0 20.91 20.91"
	>
		<g id="FAQS" transform="translate(-10571 -3565.565)">
			<path
				id="FAQS-2"
				data-name="FAQS"
				d="M11.455,21.91A10.455,10.455,0,1,1,21.91,11.455,10.455,10.455,0,0,1,11.455,21.91Zm0-19.009a8.554,8.554,0,1,0,8.554,8.554A8.554,8.554,0,0,0,11.455,2.9Zm0,15.207a1.426,1.426,0,1,1,1.426-1.426A1.426,1.426,0,0,1,11.455,18.108Zm0-3.8a.95.95,0,0,1-.95-.95,4.914,4.914,0,0,1,1.9-3.8,1.587,1.587,0,0,0,.551-1.625A1.54,1.54,0,0,0,11.835,6.75,1.578,1.578,0,0,0,9.868,8.29a.95.95,0,0,1-1.9,0,3.488,3.488,0,1,1,5.7,2.718,3.013,3.013,0,0,0-1.264,2.348A.95.95,0,0,1,11.455,14.306Z"
				transform="translate(10570 3564.565)"
				fill={color}
			/>
		</g>
	</svg>
);

export const OtherInterests = ({ color = '#65BCB0' }) => (
	<svg
		id="Other_interest"
		data-name="Other interest"
		xmlns="http://www.w3.org/2000/svg"
		width="16.01"
		height="19.576"
		viewBox="0 0 16.01 19.576"
	>
		<path
			id="Path_86129"
			data-name="Path 86129"
			d="M11.449,5A4.454,4.454,0,0,0,7,9.449a.89.89,0,1,0,1.78,0A2.669,2.669,0,0,1,11.449,6.78a.89.89,0,0,0,0-1.78Z"
			transform="translate(-3.444 -1.441)"
			fill={color}
		/>
		<path
			id="Path_86130"
			data-name="Path 86130"
			d="M11.009,1A8.008,8.008,0,0,0,7.449,16.18v.836a.89.89,0,0,0,.89.89h5.339a.89.89,0,0,0,.89-.89V16.18A8.008,8.008,0,0,0,11.009,1Zm2.336,13.78a.89.89,0,0,0-.556.825v.522H9.229V15.6a.89.89,0,0,0-.556-.825,6.229,6.229,0,1,1,4.671,0Z"
			transform="translate(-3.004 -1)"
			fill={color}
		/>
		<path
			id="Path_86131"
			data-name="Path 86131"
			d="M14.229,22.78a.89.89,0,0,0,0-1.78H8.89a.89.89,0,0,0,0,1.78Z"
			transform="translate(-3.554 -3.204)"
			fill={color}
		/>
	</svg>
);

export const Interests = ({ color = '#65BCB0' }) => (
	<svg
		id="Interest"
		xmlns="http://www.w3.org/2000/svg"
		width="28"
		height="28"
		viewBox="0 0 28 28"
	>
		<path
			id="Path_86121"
			data-name="Path 86121"
			d="M.82,381.343h8.7a2.826,2.826,0,0,0,2.7,2h3.554a2.826,2.826,0,0,0,2.7-2h8.7a.82.82,0,0,0,0-1.641h-.5v-2.861a.821.821,0,0,0-1.01-.8,12.486,12.486,0,0,1-3.3.452c-1.913-.025-2.73-.407-5-.583a3.885,3.885,0,0,0-3.4,1.521,3.885,3.885,0,0,0-3.4-1.521c-2.269.175-3.095.558-5,.583a12.492,12.492,0,0,1-3.3-.452.821.821,0,0,0-1.01.8V379.7H.82a.82.82,0,0,0,0,1.641Zm2.072-3.478a12.272,12.272,0,0,0,2.692.27c2.07-.027,2.931-.42,5.109-.588a2.415,2.415,0,0,1,2.479,1.892h0a.821.821,0,0,0,1.591,0h0a2.415,2.415,0,0,1,2.479-1.892c2.178.168,3.038.56,5.108.588a12.273,12.273,0,0,0,2.692-.27V379.7H17.777a.82.82,0,0,0-.82.82,1.181,1.181,0,0,1-1.18,1.18H12.223a1.181,1.181,0,0,1-1.18-1.18.82.82,0,0,0-.82-.82H2.892Z"
			transform="translate(0 -355.344)"
			fill={color}
		/>
		<path
			id="Path_86122"
			data-name="Path 86122"
			d="M147.317,34.189h1.689a2.35,2.35,0,0,0,2.382-2.287l.013-1.721a9.112,9.112,0,0,1,1.752-4.081,6.239,6.239,0,0,0-5.074-9.988,6.252,6.252,0,0,0-6.149,6.144,6.18,6.18,0,0,0,1.265,3.862,8.972,8.972,0,0,1,1.739,4.052v1.715A2.346,2.346,0,0,0,147.317,34.189Zm2.431-2.3a.708.708,0,0,1-.741.658h-1.689a.706.706,0,0,1-.741-.663v-.978h3.179Zm-6.176-9.609a4.6,4.6,0,0,1,9.195.07,4.554,4.554,0,0,1-.923,2.763,10.775,10.775,0,0,0-1.937,4.154h-.917V24.511a.82.82,0,1,0-1.641,0v4.756h-.915a10.606,10.606,0,0,0-1.93-4.14A4.555,4.555,0,0,1,143.571,22.281Z"
			transform="translate(-134.168 -15.231)"
			fill={color}
		/>
		<path
			id="Path_86123"
			data-name="Path 86123"
			d="M37.264,101.192a.82.82,0,0,0-.82-.82H33.708a.82.82,0,1,0,0,1.641h2.735A.82.82,0,0,0,37.264,101.192Z"
			transform="translate(-31.089 -94.883)"
			fill={color}
		/>
		<path
			id="Path_86124"
			data-name="Path 86124"
			d="M392.965,176.882l2.356,1.388a.82.82,0,1,0,.833-1.414l-2.356-1.388a.82.82,0,0,0-.833,1.414Z"
			transform="translate(-371.093 -165.765)"
			fill={color}
		/>
		<path
			id="Path_86125"
			data-name="Path 86125"
			d="M47.583,178.27l2.356-1.388a.82.82,0,1,0-.833-1.414l-2.356,1.388a.82.82,0,0,0,.833,1.414Z"
			transform="translate(-43.812 -165.765)"
			fill={color}
		/>
		<path
			id="Path_86126"
			data-name="Path 86126"
			d="M393.8,2.915l2.356-1.388a.82.82,0,1,0-.833-1.414L392.966,1.5a.82.82,0,0,0,.833,1.414Z"
			transform="translate(-371.094 0)"
			fill={color}
		/>
		<path
			id="Path_86127"
			data-name="Path 86127"
			d="M49.94,1.5,47.583.113a.82.82,0,1,0-.833,1.414l2.356,1.388A.82.82,0,0,0,49.94,1.5Z"
			transform="translate(-43.812 0)"
			fill={color}
		/>
		<path
			id="Path_86128"
			data-name="Path 86128"
			d="M403.478,101.192a.82.82,0,0,0-.82-.82h-2.735a.82.82,0,1,0,0,1.641h2.735A.82.82,0,0,0,403.478,101.192Z"
			transform="translate(-377.276 -94.883)"
			fill={color}
		/>
	</svg>
);
export const FileUpload = () => (
	<svg
		id="photo"
		xmlns="http://www.w3.org/2000/svg"
		width="45.432"
		height="40.953"
		viewBox="0 0 45.432 40.953"
	>
		<path
			id="Path_85578"
			data-name="Path 85578"
			d="M9.61,126.577a3.94,3.94,0,0,1-3.835-3.056L.1,98.881a3.949,3.949,0,0,1,2.951-4.728l11.173-2.574a2.189,2.189,0,1,1,1.126,4.231c-.048.013-.1.024-.144.033L4.471,98.329l5.481,23.782,17.232-3.975a2.189,2.189,0,1,1,1.056,4.249l-.067.016-17.688,4.072A3.933,3.933,0,0,1,9.61,126.577Z"
			transform="translate(0.001 -85.624)"
			fill="#a5d8f9"
		/>
		<path
			id="Path_85579"
			data-name="Path 85579"
			d="M149.795,63.092h-.376l-24.124-2.3A3.94,3.94,0,0,1,121.74,56.5l2.627-27.687a3.94,3.94,0,0,1,4.291-3.555l24.124,2.259a3.94,3.94,0,0,1,3.555,4.291l-2.627,27.687a3.94,3.94,0,0,1-3.914,3.573Zm-23.642-6.62,23.274,2.207,2.5-26.785L128.675,29.66Z"
			transform="translate(-110.921 -25.238)"
			fill="#49b1f3"
		/>
		<g
			id="Group_53573"
			data-name="Group 53573"
			transform="translate(17.71 10.035)"
			opacity="0.467"
		>
			<path
				id="Path_85580"
				data-name="Path 85580"
				d="M218.283,240.7h0l-4.168-12.977-5.044,5.9-3.31-3.091-6.182,8.4Z"
				transform="translate(-199.58 -219.795)"
				fill="#49b1f3"
			/>
			<circle
				id="Ellipse_39"
				data-name="Ellipse 39"
				cx="2.233"
				cy="2.233"
				r="2.233"
				transform="translate(4.301)"
				fill="#49b1f3"
			/>
		</g>
	</svg>
);
export const KnowYourCommunityIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
	>
		<g
			id="General_Information"
			data-name="General Information"
			transform="translate(-287.976 -153.16)"
		>
			<path
				id="information_3_"
				data-name="information (3)"
				d="M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,17.5A7.5,7.5,0,1,1,17.5,10,7.509,7.509,0,0,1,10,17.5ZM11.25,10v4.172a1.25,1.25,0,0,1-2.5,0V10a1.25,1.25,0,0,1,2.5,0Zm0-4.189V6.1a1.25,1.25,0,0,1-2.5,0V5.811a1.25,1.25,0,0,1,2.5,0Z"
				transform="translate(287.976 153.16)"
				fill="#65BCB0"
			/>
		</g>
	</svg>
);

export const GuarantorIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
	>
		<g
			id="Guarantor_Information"
			data-name="Guarantor Information"
			transform="translate(-288 -201)"
		>
			<path
				id="Path_86112"
				data-name="Path 86112"
				d="M7,15a4,4,0,1,0-4-4A4,4,0,0,0,7,15ZM7,9a2,2,0,1,1-2,2A2,2,0,0,1,7,9Z"
				transform="translate(286 199)"
				fill="#65BCB0"
			/>
			<path
				id="Path_86113"
				data-name="Path 86113"
				d="M8,16H6a4,4,0,0,0-4,4v1a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V20A4,4,0,0,0,8,16ZM4,20a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2Z"
				transform="translate(286 199)"
				fill="#65BCB0"
			/>
			<path
				id="Path_86114"
				data-name="Path 86114"
				d="M18,11H16a4,4,0,0,0-4,4v1a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V15A4,4,0,0,0,18,11Zm-4,4a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2Z"
				transform="translate(286 199)"
				fill="#65BCB0"
			/>
			<path
				id="Path_86115"
				data-name="Path 86115"
				d="M17,10a4,4,0,1,0-4-4A4,4,0,0,0,17,10Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,17,4Z"
				transform="translate(286 199)"
				fill="#65BCB0"
			/>
		</g>
	</svg>
);

export const RefundIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18.302"
		height="18.302"
		viewBox="0 0 18.302 18.302"
	>
		<g
			id="Refund_Details"
			data-name="Refund Details"
			transform="translate(-2 -2)"
		>
			<path
				id="Path_86116"
				data-name="Path 86116"
				d="M2.915,20.3H19.387a.915.915,0,0,0,.915-.915v-3.66a.915.915,0,0,0-.915-.915h-.915V10.236h.915a.915.915,0,0,0,.915-.915V6.576a.915.915,0,0,0-.544-.836l-8.236-3.66a.915.915,0,0,0-.743,0L2.544,5.739A.915.915,0,0,0,2,6.576V9.321a.915.915,0,0,0,.915.915H3.83v4.576H2.915A.915.915,0,0,0,2,15.727v3.66a.915.915,0,0,0,.915.915ZM3.83,7.17l7.321-3.254L18.472,7.17V8.406H3.83Zm12.812,3.066v4.576H14.2V10.236Zm-4.271,0v4.576H9.931V10.236Zm-4.27,0v4.576H5.66V10.236ZM3.83,16.642H18.472v1.83H3.83Z"
				fill="#65BCB0"
			/>
			<path
				id="Path_86117"
				data-name="Path 86117"
				d="M12.745,6h-1.83a.915.915,0,0,0,0,1.83h1.83a.915.915,0,0,0,0-1.83Z"
				transform="translate(-0.679 -0.34)"
				fill="#65BCB0"
			/>
		</g>
	</svg>
);

export const BookingID = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16.314"
		height="16.31"
		viewBox="0 0 16.314 16.31"
	>
		<g id="Booking_id" data-name="Booking id" transform="translate(-0.001 0)">
			<path
				id="Path_86145"
				data-name="Path 86145"
				d="M11.741,11a.741.741,0,0,0-.741.741v3.707a.741.741,0,1,0,1.483,0V11.741A.741.741,0,0,0,11.741,11Z"
				transform="translate(-3.59 -3.588)"
				fill={color}
			/>
			<ellipse
				id="Ellipse_55"
				data-name="Ellipse 55"
				cx="1.112"
				cy="1.112"
				rx="1.112"
				ry="1.112"
				transform="translate(7.04 3.704)"
				fill={color}
			/>
			<path
				id="Path_86144"
				data-name="Path 86144"
				d="M14.927,3.389A8.156,8.156,0,0,0,1.944,12.954l-.586,2.187a1.486,1.486,0,0,0,1.817,1.817l2.187-.586a8.075,8.075,0,0,0,3.8.942,8.594,8.594,0,0,0,1.231-.089A8.156,8.156,0,0,0,14.927,3.389Zm.9,6.377a6.673,6.673,0,0,1-9.973,5.19.742.742,0,0,0-.371-.1.853.853,0,0,0-.193,0l-2.477.667.667-2.477a.741.741,0,0,0-.074-.564,6.673,6.673,0,1,1,12.42-2.721Z"
				transform="translate(-1.007 -1.004)"
				fill={color}
			/>
		</g>
	</svg>
);

export const GuarantorWarning = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="13.463"
		height="13.463"
		viewBox="0 0 13.463 13.463"
	>
		<path
			id="ic_info_outline_24px"
			d="M8.058,12.1H9.4V8.058H8.058ZM8.732,2a6.732,6.732,0,1,0,6.732,6.732A6.734,6.734,0,0,0,8.732,2Zm0,12.117a5.385,5.385,0,1,1,5.385-5.385A5.392,5.392,0,0,1,8.732,14.117Zm-.673-7.4H9.4V5.366H8.058Z"
			transform="translate(-2 -2)"
			fill="#e5c287"
		/>
	</svg>
);
export const NotificationsMore = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="25"
		viewBox="0 0 21 25"
	>
		<g
			id="notification_with_circle"
			data-name="notification with circle"
			transform="translate(-1348 461)"
		>
			<g
				id="Component_172_43"
				data-name="Component 172 – 43"
				transform="translate(1348 -461)"
			>
				<path
					id="notification-bell"
					d="M3,18a1,1,0,0,0,1,1H8a4,4,0,0,0,8,0h4a1,1,0,0,0,0-2h-.184A2.965,2.965,0,0,0,20,16V11a8.007,8.007,0,0,0-6-7.737V3a2,2,0,0,0-4,0v.263A8.007,8.007,0,0,0,4,11v5a2.965,2.965,0,0,0,.184,1H4A1,1,0,0,0,3,18Zm9,3a2,2,0,0,1-2-2h4A2,2,0,0,1,12,21ZM6,16V11a6,6,0,0,1,12,0v5a1,1,0,0,1-1,1H7A1,1,0,0,1,6,16Z"
					transform="translate(-3 2)"
					fill="#5a5b5d"
				/>
				<circle
					id="Ellipse_2"
					data-name="Ellipse 2"
					cx="6"
					cy="6"
					r="6"
					transform="translate(9)"
					fill="#ef571b"
				/>
			</g>
		</g>
	</svg>
);

export const SearchIcon = ({ color = '#000000' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="12"
		height="12"
		viewBox="0 0 17.055 17.052"
	>
		<g id="search" transform="translate(0 -0.035)">
			<path
				id="Path_85683"
				data-name="Path 85683"
				d="M6.864,13.756a6.847,6.847,0,0,0,4.208-1.445l4.537,4.537a.853.853,0,0,0,1.206-1.206L12.278,11.1a6.86,6.86,0,1,0-5.414,2.652ZM3.219,3.251a5.156,5.156,0,1,1,0,7.291h0a5.137,5.137,0,0,1-.027-7.265l.027-.027Z"
				transform="translate(0 0)"
				fill={color}
			/>
		</g>
	</svg>
);
export const CheckMarkIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="22"
		viewBox="0 0 22 22"
	>
		<g
			id="Current_booking"
			data-name="Current booking"
			transform="translate(-1 -1)"
		>
			<path
				id="Path_86262"
				data-name="Path 86262"
				d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z"
				fill="#ffffff"
			/>
			<path
				id="Path_86263"
				data-name="Path 86263"
				d="M16.324,8.763,11.03,13.616,8.707,11.293a1,1,0,1,0-1.414,1.414l3,3a1,1,0,0,0,1.383.03l6-5.5a1,1,0,1,0-1.352-1.474Z"
				fill="#ffffff"
			/>
		</g>
	</svg>
);

export const Logout = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="19.044"
		height="19.039"
		viewBox="0 0 19.044 19.039"
	>
		<g id="Logout" transform="translate(-10571.933 -3617.546)">
			<path
				id="logout_3_"
				data-name="logout (3)"
				d="M10.519,20.039H3.6a2.6,2.6,0,0,1-2.6-2.6V3.6A2.6,2.6,0,0,1,3.6,1h6.923a2.6,2.6,0,0,1,2.6,2.6V5.327a.865.865,0,1,1-1.731,0V3.6a.865.865,0,0,0-.865-.865H3.6a.865.865,0,0,0-.865.865V17.443a.865.865,0,0,0,.865.865h6.923a.865.865,0,0,0,.865-.865V15.712a.865.865,0,1,1,1.731,0v1.731A2.6,2.6,0,0,1,10.519,20.039Zm5.192-5.192a.865.865,0,0,1-.614-1.48l1.99-1.982H5.327a.865.865,0,1,1,0-1.731H17.088L15.1,7.672a.869.869,0,1,1,1.229-1.229l3.462,3.462a.865.865,0,0,1,0,1.229L16.326,14.6a.865.865,0,0,1-.614.251Z"
				transform="translate(10570.933 3616.546)"
				fill={color}
			/>
		</g>
	</svg>
);

export const SolidArrow = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="6.614"
		height="3.61"
		viewBox="0 0 6.614 3.61"
	>
		<g
			id="Solid_arrow"
			data-name="Solid arrow"
			transform="translate(-295 -266.629)"
		>
			<path
				id="Path_85309"
				data-name="Path 85309"
				d="M11.1,8.18H5.51a.509.509,0,0,0-.359.869L7.6,11.5a1.006,1.006,0,0,0,1.422,0l.931-.931,1.516-1.516A.511.511,0,0,0,11.1,8.18Z"
				transform="translate(290 258.45)"
				fill="#6e6f71"
			/>
		</g>
	</svg>
);

export const RightArrow = ({ color = '#65BCB0' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		height="20"
		viewBox="0 -960 960 960"
		width="20"
	>
		<path
			d="m304-82-56-57 343-343-343-343 56-57 400 400L304-82Z"
			fill={color}
		/>
	</svg>
);
export const ChangePassword = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20.91"
		height="20.897"
		viewBox="0 0 20.91 20.897"
	>
		<g
			id="Chnage_password"
			data-name="Chnage password"
			transform="translate(-10571 -3514.565)"
		>
			<path
				id="Path_86147"
				data-name="Path 86147"
				d="M18.1,12.4a3.8,3.8,0,0,0-3.667,2.85H12.4V14.3a.95.95,0,1,0-1.9,0v.95H8.6V14.3a.95.95,0,1,0-1.9,0v.95h-.95a.95.95,0,1,0,0,1.9h8.682A3.8,3.8,0,1,0,18.1,12.4Zm0,5.7A1.9,1.9,0,1,1,20,16.2,1.9,1.9,0,0,1,18.1,18.1Zm-4.749,2.85a.95.95,0,0,1-.95.95H5.749A4.749,4.749,0,0,1,1,17.148V5.749A4.749,4.749,0,0,1,5.749,1h7.6A4.749,4.749,0,0,1,18.1,5.749v3.8a.95.95,0,1,1-1.9,0v-3.8a2.85,2.85,0,0,0-2.85-2.85h-7.6A2.85,2.85,0,0,0,2.9,5.749v11.4A2.85,2.85,0,0,0,5.749,20H12.4A.95.95,0,0,1,13.348,20.947ZM14.3,10.5a.95.95,0,0,1-.95.95h-7.6a.95.95,0,1,1,0-1.9h7.6A.95.95,0,0,1,14.3,10.5Zm0-3.8a.95.95,0,0,1-.95.95h-7.6a.95.95,0,0,1,0-1.9h7.6A.95.95,0,0,1,14.3,6.7Z"
				transform="translate(10570 3513.565)"
				fill={color}
			/>
		</g>
	</svg>
);

export const CloseIcon = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="12.617"
		height="12.472"
		viewBox="0 0 12.617 12.472"
	>
		<g id="close" transform="translate(0 -1.844)">
			<g id="close_1_" transform="translate(0.001 1.844)">
				<path
					id="Path_86335"
					data-name="Path 86335"
					d="M1.2,14.912a1.2,1.2,0,0,1-.849-.287,1.2,1.2,0,0,1,0-1.685L10.494,2.793a1.2,1.2,0,0,1,1.745,1.625L2.033,14.625a1.2,1.2,0,0,1-.837.287Z"
					transform="translate(-0.001 -2.446)"
					fill={color}
				/>
				<path
					id="Path_86336"
					data-name="Path 86336"
					d="M12.8,14.31a1.2,1.2,0,0,1-.837-.347L1.816,3.816A1.2,1.2,0,0,1,3.5,2.131L13.707,12.278a1.2,1.2,0,0,1,.056,1.689q-.027.029-.056.056a1.2,1.2,0,0,1-.908.287Z"
					transform="translate(-1.468 -1.844)"
					fill={color}
				/>
			</g>
		</g>
	</svg>
);

export const FAQ = (color = '#6E6F71') => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20.91"
		height="20.91"
		viewBox="0 0 20.91 20.91"
	>
		<g id="FAQS" transform="translate(-10571 -3565.565)">
			<path
				id="FAQS-2"
				data-name="FAQS"
				d="M11.455,21.91A10.455,10.455,0,1,1,21.91,11.455,10.455,10.455,0,0,1,11.455,21.91Zm0-19.009a8.554,8.554,0,1,0,8.554,8.554A8.554,8.554,0,0,0,11.455,2.9Zm0,15.207a1.426,1.426,0,1,1,1.426-1.426A1.426,1.426,0,0,1,11.455,18.108Zm0-3.8a.95.95,0,0,1-.95-.95,4.914,4.914,0,0,1,1.9-3.8,1.587,1.587,0,0,0,.551-1.625A1.54,1.54,0,0,0,11.835,6.75,1.578,1.578,0,0,0,9.868,8.29a.95.95,0,0,1-1.9,0,3.488,3.488,0,1,1,5.7,2.718,3.013,3.013,0,0,0-1.264,2.348A.95.95,0,0,1,11.455,14.306Z"
				transform="translate(10570 3564.565)"
				fill={color}
			/>
		</g>
	</svg>
);

export const HamburgerMenu = () => (
	<svg
		width="31.994"
		height="22.396"
		viewBox="0 0 31.994 22.396"
	>
		<path
			id="menu_1_"
			data-name="menu (1)"
			d="M24,78.4a1.6,1.6,0,0,0-1.6-1.6H1.6a1.6,1.6,0,1,0,0,3.2H22.4A1.6,1.6,0,0,0,24,78.4Zm-22.4,8H30.394a1.6,1.6,0,0,1,0,3.2H1.6a1.6,1.6,0,1,1,0-3.2Zm0,9.6H16a1.6,1.6,0,1,1,0,3.2H1.6a1.6,1.6,0,1,1,0-3.2Z"
			transform="translate(0 -76.8)"
		/>
	</svg>
);

export const HamburgerMenuMobile = () => (
	<svg 
		viewBox="64 64 896 896"
		focusable="false"
		data-icon="menu"
		width="31"
		height="22" 
		fill="currentColor" 
		aria-hidden="true">
		<path 
			d="M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
			fill={"#000000"}
			>
			</path>
	</svg>
)

export const RefundsMobileIcon=({color="white"})=>(
	<svg xmlns="http://www.w3.org/2000/svg" width="19.521"
	height="19.551"
	viewBox="0 0 19.521 19.551">
    <g data-name="refund (1)">
      <g data-name="Group 116462">
        <g data-name="Group 116461">
          <path
            d="m12.23 3.653-.831 1.067a6.231 6.231 0 1 1-3.477-1.3L6.753 4.65l.867.828L9.466 3.54l.827-.868-.867-.827L7.493 0l-.827.868 1.262 1.2a7.579 7.579 0 0 0-1.525 15.061 7.66 7.66 0 0 0 1.194.094 7.582 7.582 0 0 0 4.633-13.57Z"
            data-name="Path 90420"
			fill={color}
          />
          <path
            d="M8.323 13.507v-.778a1.852 1.852 0 0 0 1.821-1.793c0-1.5-1.4-1.676-2.42-1.8-.653-.078-1.153-.169-1.153-.564 0-.55.775-.609 1.109-.609a1.5 1.5 0 0 1 1.2.529l.052.086 1.026-.475-.051-.1a2.025 2.025 0 0 0-1.587-1.1v-.685h-1.2v.683c-1.118.165-1.782.786-1.782 1.674 0 1.448 1.315 1.595 2.274 1.7.855.1 1.253.312 1.253.664 0 .672-.931.725-1.216.725a1.566 1.566 0 0 1-1.425-.738l-.044-.1-1.114.472.044.1a2.351 2.351 0 0 0 2.011 1.371v.741Z"
            data-name="Path 90421"
			fill={color}
          />
        </g>
      </g>
    </g>
  </svg>
)

export const StudentProof = ({ color = '#6e6f71' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="19.521"
		height="19.551"
		viewBox="0 0 19.521 19.551"
	>
		<g
			id="Student_proof"
			data-name="Student proof"
			transform="translate(-10.035 -10.002)"
		>
			<g id="LINE_539_" transform="translate(22.906 16.261)">
				<g id="Group_54684" data-name="Group 54684">
					<path
						id="Path_86337"
						data-name="Path 86337"
						d="M39.889,34.268A.889.889,0,0,1,39,33.38v-8.4a.889.889,0,1,1,1.777,0v8.4A.889.889,0,0,1,39.889,34.268Z"
						transform="translate(-39 -24.087)"
						
					/>
				</g>
			</g>
			<g id="CIRCLE_62_" transform="translate(21.35 24.665)">
				<g id="Group_54685" data-name="Group 54685" transform="translate(0 0)">
					<path
						id="Path_86338"
						data-name="Path 86338"
						d="M37.944,47.888a2.444,2.444,0,1,1,2.444-2.444A2.477,2.477,0,0,1,37.944,47.888Zm0-3.11a.667.667,0,1,0,.667.667A.693.693,0,0,0,37.944,44.777Z"
						transform="translate(-35.5 -43)"
						fill={color}
					/>
				</g>
			</g>
			<g id="ARC_225_" transform="translate(24.4 19.379)">
				<g id="Group_54686" data-name="Group 54686">
					<path
						id="Path_86339"
						data-name="Path 86339"
						d="M43.253,34.555a.889.889,0,0,1-.3-1.725.89.89,0,0,0,.585-.835.889.889,0,0,1,1.777,0A2.674,2.674,0,0,1,43.555,34.5.892.892,0,0,1,43.253,34.555Z"
						transform="translate(-42.364 -31.106)"
						fill={color}
					/>
				</g>
			</g>
			<g id="LINE_540_" transform="translate(25.572 15.294)">
				<g id="Group_54687" data-name="Group 54687">
					<path
						id="Path_86340"
						data-name="Path 86340"
						d="M45.889,27.774A.889.889,0,0,1,45,26.886V22.8a.889.889,0,0,1,1.777,0v4.086A.889.889,0,0,1,45.889,27.774Z"
						transform="translate(-45 -21.911)"
						fill={color}
					/>
				</g>
			</g>
			<g id="LINE_541_" transform="translate(20.409 21.05)">
				<g id="Group_54688" data-name="Group 54688" transform="translate(0 0)">
					<path
						id="Path_86341"
						data-name="Path 86341"
						d="M34.27,38.092a.889.889,0,0,1-.3-1.725l3.991-1.448a.889.889,0,1,1,.607,1.671l-3.991,1.448A.887.887,0,0,1,34.27,38.092Z"
						transform="translate(-33.381 -34.866)"
						fill={color}
					/>
				</g>
			</g>
			<g id="ARC_226_" transform="translate(12.241 19.379)">
				<g id="Group_54689" data-name="Group 54689" transform="translate(0)">
					<path
						id="Path_86342"
						data-name="Path 86342"
						d="M17.06,34.555a.891.891,0,0,1-.3-.053A2.673,2.673,0,0,1,15,31.995a.889.889,0,1,1,1.777,0,.89.89,0,0,0,.585.835.889.889,0,0,1-.3,1.725Z"
						transform="translate(-15 -31.106)"
						fill={color}
					/>
				</g>
			</g>
			<g id="LINE_542_" transform="translate(12.241 15.294)">
				<g id="Group_54690" data-name="Group 54690" transform="translate(0)">
					<path
						id="Path_86343"
						data-name="Path 86343"
						d="M15.889,27.774A.889.889,0,0,1,15,26.886V22.8a.889.889,0,1,1,1.777,0v4.086A.889.889,0,0,1,15.889,27.774Z"
						transform="translate(-15 -21.911)"
						fill={color}
					/>
				</g>
			</g>
			<g id="LINE_543_" transform="translate(13.413 21.05)">
				<g id="Group_54691" data-name="Group 54691">
					<path
						id="Path_86344"
						data-name="Path 86344"
						d="M22.517,38.092a.883.883,0,0,1-.3-.054l-3.991-1.448a.889.889,0,1,1,.607-1.671l3.991,1.448a.889.889,0,0,1-.3,1.725Z"
						transform="translate(-17.636 -34.866)"
						fill={color}
					/>
				</g>
			</g>
			<g id="ARC_227_" transform="translate(17.404 22.498)">
				<g id="Group_54692" data-name="Group 54692">
					<path
						id="Path_86345"
						data-name="Path 86345"
						d="M29.009,40.165a5.288,5.288,0,0,1-1.805-.317.889.889,0,1,1,.606-1.671,3.526,3.526,0,0,0,2.4,0,.889.889,0,1,1,.606,1.671A5.3,5.3,0,0,1,29.009,40.165Z"
						transform="translate(-26.618 -38.124)"
						fill={color}
					/>
				</g>
			</g>
			<g id="ARC_228_" transform="translate(10.035 12.679)">
				<g id="Group_54693" data-name="Group 54693">
					<path
						id="Path_86346"
						data-name="Path 86346"
						d="M11.634,19.877a.883.883,0,0,1-.3-.054,2,2,0,0,1,0-3.742.889.889,0,1,1,.606,1.671.223.223,0,0,0,0,.4.889.889,0,0,1-.3,1.725Z"
						transform="translate(-10.035 -16.027)"
						fill={color}
					/>
				</g>
			</g>
			<g id="LINE_544_" transform="translate(10.745 14.751)">
				<g id="Group_54694" data-name="Group 54694" transform="translate(0 0)">
					<path
						id="Path_86347"
						data-name="Path 86347"
						d="M19.181,24.883a.883.883,0,0,1-.3-.054l-6.659-2.415a.889.889,0,1,1,.606-1.671l6.659,2.415a.889.889,0,0,1-.3,1.725Z"
						transform="translate(-11.633 -20.689)"
						fill={color}
					/>
				</g>
			</g>
			<g id="LINE_545_" transform="translate(10.745 10.264)">
				<g id="Group_54695" data-name="Group 54695" transform="translate(0 0)">
					<path
						id="Path_86348"
						data-name="Path 86348"
						d="M12.523,14.785a.889.889,0,0,1-.3-1.725l6.659-2.415a.889.889,0,1,1,.606,1.671l-6.659,2.415A.887.887,0,0,1,12.523,14.785Z"
						transform="translate(-11.634 -10.592)"
						fill={color}
					/>
				</g>
			</g>
			<g id="ARC_229_" transform="translate(27.067 12.679)">
				<g id="Group_54696" data-name="Group 54696" transform="translate(0)">
					<path
						id="Path_86349"
						data-name="Path 86349"
						d="M49.255,19.877a.889.889,0,0,1-.3-1.725.223.223,0,0,0,0-.4.889.889,0,1,1,.607-1.671,2,2,0,0,1,0,3.742.887.887,0,0,1-.3.054Z"
						transform="translate(-48.366 -16.027)"
						fill={color}
					/>
				</g>
			</g>
			<g id="LINE_546_" transform="translate(20.409 10.265)">
				<g id="Group_54697" data-name="Group 54697" transform="translate(0 0)">
					<path
						id="Path_86350"
						data-name="Path 86350"
						d="M40.928,14.786a.883.883,0,0,1-.3-.054l-6.658-2.414a.889.889,0,1,1,.606-1.671l6.659,2.415a.889.889,0,0,1-.3,1.724Z"
						transform="translate(-33.381 -10.593)"
						fill={color}
					/>
				</g>
			</g>
			<g id="LINE_547_" transform="translate(20.409 14.75)">
				<g id="Group_54698" data-name="Group 54698">
					<path
						id="Path_86351"
						data-name="Path 86351"
						d="M34.27,24.882a.889.889,0,0,1-.3-1.725l6.659-2.415a.889.889,0,1,1,.606,1.671l-6.658,2.415A.887.887,0,0,1,34.27,24.882Z"
						transform="translate(-33.381 -20.688)"
						fill={color}
					/>
				</g>
			</g>
			<g id="ARC_230_" transform="translate(17.404 17.166)">
				<g id="Group_54699" data-name="Group 54699">
					<path
						id="Path_86352"
						data-name="Path 86352"
						d="M29.009,28.165a5.288,5.288,0,0,1-1.805-.317.889.889,0,1,1,.606-1.671,3.526,3.526,0,0,0,2.4,0,.889.889,0,1,1,.606,1.671A5.294,5.294,0,0,1,29.009,28.165Z"
						transform="translate(-26.618 -26.124)"
						fill={color}
					/>
				</g>
			</g>
			<g id="ARC_231_" transform="translate(17.403 10.002)">
				<g id="Group_54700" data-name="Group 54700">
					<path
						id="Path_86353"
						data-name="Path 86353"
						d="M30.512,12.043a.887.887,0,0,1-.3-.054,3.524,3.524,0,0,0-2.4,0,.889.889,0,1,1-.607-1.671,5.3,5.3,0,0,1,3.612,0,.889.889,0,0,1-.3,1.725Z"
						transform="translate(-26.617 -10.002)"
						fill={color}
					/>
				</g>
			</g>
		</g>
	</svg>
);

export const VukaIcon = ({ color = '#263A80' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="100.22"
		height="52.033"
		viewBox="0 0 150.22 52.033"
	>
		<g id="Layer_2" data-name="Layer 2" transform="translate(0 0.009)">
			<g id="Layer_1" data-name="Layer 1" transform="translate(0 -0.009)">
				<g id="vuka_logo_dark" data-name="vuka logo dark">
					<g id="Group_960" data-name="Group 960">
						<g id="vuka" transform="translate(0 6.947)">
							<g id="Group_54673" data-name="Group 54673">
								<path
									id="Path_86277"
									data-name="Path 86277"
									d="M0,26.87H14.44L19.784,43.5l5.391-16.63H39.44L26.031,60.246H13.41Z"
									transform="translate(0 -15.704)"
									fill={color}
								/>
								<path
									id="Path_86278"
									data-name="Path 86278"
									d="M61.24,48.716V26.87H75.013V44.289c0,2.85,1.7,4.488,3.76,4.488s3.949-1.637,3.949-4.488V26.87H96.5V59.976H82.722v-4.4a12.682,12.682,0,0,1-10.108,5.216C65.607,60.791,61.24,56.182,61.24,48.716Z"
									transform="translate(-19.974 -15.704)"
									fill={color}
								/>
								<path
									id="Path_86279"
									data-name="Path 86279"
									d="M119.69,10.3h13.773V31.661l7.1-10.2h14.993L145.175,34.943l10.559,19.629h-14.75l-4.791-9.1-2.729,3.524v5.579H119.69Z"
									transform="translate(-39.038 -10.3)"
									fill={color}
								/>
								<path
									id="Path_86280"
									data-name="Path 86280"
									d="M172.19,50.329v-.121c0-6.61,4.919-10.317,12.621-10.317a25.822,25.822,0,0,1,7.83,1.22v-.546c0-3.039-1.88-4.8-6.132-4.8a23.975,23.975,0,0,0-9.158,1.88l-2.433-9.164a37.944,37.944,0,0,1,13.989-2.426c6.738,0,11.1,1.395,14.016,4.313,2.486,2.486,3.457,5.7,3.457,10.5V59.709h-13.8V56.34a12.493,12.493,0,0,1-9.528,4.124C176.678,60.525,172.19,56.886,172.19,50.329Zm20.572-2.85V46.084a9.481,9.481,0,0,0-3.181-.526c-2.736,0-4.252,1.637-4.252,3.7v.121a3.079,3.079,0,0,0,3.16,3.221C190.93,52.58,192.762,50.633,192.762,47.479Z"
									transform="translate(-56.161 -15.438)"
									fill={color}
								/>
							</g>
						</g>
						<path
							id="Path_738"
							data-name="Path 738"
							d="M206.573,2.693A30.761,30.761,0,0,0,196.8.1a14.427,14.427,0,0,0-6.509.674,10.586,10.586,0,0,0-5.115,3.935,9.063,9.063,0,0,0-1.348,3.538,11.456,11.456,0,0,1-.849,2.823,5.506,5.506,0,0,1-1.4,1.792l.391.539c.074-.081.148-.155.216-.236a14.366,14.366,0,0,0,1.348-1.934,23.49,23.49,0,0,1,2.271-3.511,11.4,11.4,0,0,1,5.586-3.511c1.7-.472,3.45-.775,5.175-1.152h.115l.034.088a1.548,1.548,0,0,0-.424.094c-1.307.364-2.628.674-3.922,1.1a13.982,13.982,0,0,0-5.546,3.214,11.986,11.986,0,0,0-2.507,3.666.3.3,0,0,0,.061.276,8.639,8.639,0,0,0,6.644,1.6,9.387,9.387,0,0,0,5.2-2.965c1.287-1.348,2.6-2.662,3.969-3.908a11.273,11.273,0,0,1,5.445-2.857,12.924,12.924,0,0,1,1.833-.067h.256C207.328,3.09,206.964,2.868,206.573,2.693Z"
							transform="translate(-59.223 0.009)"
							fill="#a3ce59"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const VukaIconMobile = ({ color = '#263A80' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="80.22"
		height="40.033"
		viewBox="0 0 150.22 52.033"
	>
		<g id="Layer_2" data-name="Layer 2" transform="translate(0 0.009)">
			<g id="Layer_1" data-name="Layer 1" transform="translate(0 -0.009)">
				<g id="vuka_logo_dark" data-name="vuka logo dark">
					<g id="Group_960" data-name="Group 960">
						<g id="vuka" transform="translate(0 6.947)">
							<g id="Group_54673" data-name="Group 54673">
								<path
									id="Path_86277"
									data-name="Path 86277"
									d="M0,26.87H14.44L19.784,43.5l5.391-16.63H39.44L26.031,60.246H13.41Z"
									transform="translate(0 -15.704)"
									fill={color}
								/>
								<path
									id="Path_86278"
									data-name="Path 86278"
									d="M61.24,48.716V26.87H75.013V44.289c0,2.85,1.7,4.488,3.76,4.488s3.949-1.637,3.949-4.488V26.87H96.5V59.976H82.722v-4.4a12.682,12.682,0,0,1-10.108,5.216C65.607,60.791,61.24,56.182,61.24,48.716Z"
									transform="translate(-19.974 -15.704)"
									fill={color}
								/>
								<path
									id="Path_86279"
									data-name="Path 86279"
									d="M119.69,10.3h13.773V31.661l7.1-10.2h14.993L145.175,34.943l10.559,19.629h-14.75l-4.791-9.1-2.729,3.524v5.579H119.69Z"
									transform="translate(-39.038 -10.3)"
									fill={color}
								/>
								<path
									id="Path_86280"
									data-name="Path 86280"
									d="M172.19,50.329v-.121c0-6.61,4.919-10.317,12.621-10.317a25.822,25.822,0,0,1,7.83,1.22v-.546c0-3.039-1.88-4.8-6.132-4.8a23.975,23.975,0,0,0-9.158,1.88l-2.433-9.164a37.944,37.944,0,0,1,13.989-2.426c6.738,0,11.1,1.395,14.016,4.313,2.486,2.486,3.457,5.7,3.457,10.5V59.709h-13.8V56.34a12.493,12.493,0,0,1-9.528,4.124C176.678,60.525,172.19,56.886,172.19,50.329Zm20.572-2.85V46.084a9.481,9.481,0,0,0-3.181-.526c-2.736,0-4.252,1.637-4.252,3.7v.121a3.079,3.079,0,0,0,3.16,3.221C190.93,52.58,192.762,50.633,192.762,47.479Z"
									transform="translate(-56.161 -15.438)"
									fill={color}
								/>
							</g>
						</g>
						<path
							id="Path_738"
							data-name="Path 738"
							d="M206.573,2.693A30.761,30.761,0,0,0,196.8.1a14.427,14.427,0,0,0-6.509.674,10.586,10.586,0,0,0-5.115,3.935,9.063,9.063,0,0,0-1.348,3.538,11.456,11.456,0,0,1-.849,2.823,5.506,5.506,0,0,1-1.4,1.792l.391.539c.074-.081.148-.155.216-.236a14.366,14.366,0,0,0,1.348-1.934,23.49,23.49,0,0,1,2.271-3.511,11.4,11.4,0,0,1,5.586-3.511c1.7-.472,3.45-.775,5.175-1.152h.115l.034.088a1.548,1.548,0,0,0-.424.094c-1.307.364-2.628.674-3.922,1.1a13.982,13.982,0,0,0-5.546,3.214,11.986,11.986,0,0,0-2.507,3.666.3.3,0,0,0,.061.276,8.639,8.639,0,0,0,6.644,1.6,9.387,9.387,0,0,0,5.2-2.965c1.287-1.348,2.6-2.662,3.969-3.908a11.273,11.273,0,0,1,5.445-2.857,12.924,12.924,0,0,1,1.833-.067h.256C207.328,3.09,206.964,2.868,206.573,2.693Z"
							transform="translate(-59.223 0.009)"
							fill="#a3ce59"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export const NewIcon = () => (
	<svg
		data-name="Group 54788"
		xmlns="http://www.w3.org/2000/svg"
		width={146.167}
		height={52.918}
	>
		<defs>
			<clipPath id="a">
				<path
					data-name="Rectangle 8791"
					fill="none"
					d="M0 0h146.167v52.918H0z"
				/>
			</clipPath>
			<clipPath id="b">
				<path
					data-name="Path 86198"
					d="M26.29 8.955A24.416 24.416 0 0 0 11.6 42.247C15.509 51 22.576 55.8 32.052 56.9a23.243 23.243 0 0 0 14.139-2.92 4.515 4.515 0 0 0 .337-7.869c-1.78-1.122-3.544-.8-5.336.107A14.529 14.529 0 0 1 30.6 47.383c-6.414-1.724-10.489-5.925-11.683-12.4a14.554 14.554 0 0 1 5.924-15.008c5.229-3.937 10.966-4.379 16.824-1.389a15.391 15.391 0 0 1 7.177 19.36c-1.518 3.809-1.21 5.033 1.941 7.664 3.185 2.658 6.364 5.322 9.564 7.962a4.588 4.588 0 1 0 5.9-7 344.933 344.933 0 0 0-7.209-6 1.677 1.677 0 0 1-.7-2.009 21.267 21.267 0 0 0 .858-6.217 33.322 33.322 0 0 0-.255-3.562 25 25 0 0 0-1.092-4.447C53.952 13.88 44.878 7.591 34.618 7.592a26.7 26.7 0 0 0-8.328 1.363"
					transform="translate(-9.428 -7.592)"
					fill="none"
				/>
			</clipPath>
		</defs>
		<g data-name="Group 54362">
			<g data-name="Group 54361" clipPath="url(#a)" fill="#65bcb0">
				<path
					data-name="Path 86194"
					d="M65.385 35.032v-.076A10.65 10.65 0 0 1 76.374 24.27a9.7 9.7 0 0 1 8.753 4.585l-4.891 3.638a4.418 4.418 0 0 0-3.827-2.16c-2.312 0-4.017 2.046-4.017 4.547v.076c0 2.652 1.668 4.66 4.092 4.66a4.915 4.915 0 0 0 3.941-2.122l4.812 3.486a10.173 10.173 0 0 1-9.132 4.7 10.578 10.578 0 0 1-10.724-10.648"
				/>
				<path
					data-name="Path 86195"
					d="M86.754 39.313v-.076c0-4.244 3.221-6.442 8.033-6.442a15.729 15.729 0 0 1 4.926.8v-.341c0-2.122-1.326-3.335-4.092-3.335a14.436 14.436 0 0 0-5.646 1.137l-1.477-5.077a20.581 20.581 0 0 1 8.3-1.592c3.676 0 6.177.872 7.806 2.5 1.554 1.516 2.2 3.638 2.2 6.517v11.782H99.68v-2.119a7.731 7.731 0 0 1-6.025 2.576c-3.9 0-6.9-2.236-6.9-6.328m13.035-1.554v-.947a7.537 7.537 0 0 0-2.8-.53c-2.084 0-3.3 1.023-3.3 2.538v.076a2.259 2.259 0 0 0 2.539 2.236 3.3 3.3 0 0 0 3.562-3.373"
				/>
				<path
					data-name="Path 86196"
					d="M110.473 24.686h7.2v4.13c1.175-2.8 3.069-4.622 6.48-4.471v7.579h-.606c-3.752 0-5.874 2.16-5.874 6.9v6.366h-7.2Z"
				/>
				<path
					data-name="Path 86197"
					d="M125.478 35.031v-.076c0-5.987 4.282-10.723 10.345-10.723 7.086 0 10.345 5.191 10.345 11.216 0 .455 0 .985-.038 1.478h-13.718a4.231 4.231 0 0 0 4.433 3.372 6.186 6.186 0 0 0 4.547-2.084l3.979 3.3a10.737 10.737 0 0 1-8.9 4.168c-6.442 0-10.989-4.282-10.989-10.648m13.944-1.781c-.265-2.274-1.592-3.713-3.562-3.713-1.895 0-3.183 1.477-3.562 3.713Z"
				/>
			</g>
		</g>
		<g data-name="Group 54364">
			<g
				data-name="Group 54363"
				clipPath="url(#b)"
				transform="translate(3.774 3.039)"
			>
				<path
					data-name="Rectangle 8792"
					fill="#397fb7"
					d="M-.245-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8793"
					fill="#397fb7"
					d="M.155-3.039h.399v52.918H.155z"
				/>
				<path
					data-name="Rectangle 8794"
					fill="#3a7fb7"
					d="M.554-3.039h.399v52.918H.554z"
				/>
				<path
					data-name="Rectangle 8795"
					fill="#3a80b7"
					d="M.953-3.039h.399v52.918H.953z"
				/>
				<path
					data-name="Rectangle 8796"
					fill="#3a80b7"
					d="M1.352-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8797"
					fill="#3a81b7"
					d="M1.751-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8798"
					fill="#3b81b7"
					d="M2.151-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8799"
					fill="#3a82b7"
					d="M2.55-3.039h.399v52.918H2.55z"
				/>
				<path
					data-name="Rectangle 8800"
					fill="#3b82b6"
					d="M2.949-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8801"
					fill="#3b82b7"
					d="M3.348-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8802"
					fill="#3b83b6"
					d="M3.747-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8803"
					fill="#3c83b6"
					d="M4.147-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8804"
					fill="#3c83b6"
					d="M4.546-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8805"
					fill="#3c84b6"
					d="M4.945-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8806"
					fill="#3c84b6"
					d="M5.344-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8807"
					fill="#3c85b6"
					d="M5.743-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8808"
					fill="#3d85b6"
					d="M6.142-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8809"
					fill="#3d86b6"
					d="M6.541-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8810"
					fill="#3d86b5"
					d="M6.94-3.039h.399v52.918H6.94z"
				/>
				<path
					data-name="Rectangle 8811"
					fill="#3d86b5"
					d="M7.34-3.039h.399v52.918H7.34z"
				/>
				<path
					data-name="Rectangle 8812"
					fill="#3d87b5"
					d="M7.739-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8813"
					fill="#3e87b5"
					d="M8.138-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8814"
					fill="#3e88b5"
					d="M8.537-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8815"
					fill="#3e88b5"
					d="M8.936-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8816"
					fill="#3e88b5"
					d="M9.335-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8817"
					fill="#3f89b5"
					d="M9.735-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8818"
					fill="#3f89b4"
					d="M10.134-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8819"
					fill="#3f8ab4"
					d="M10.533-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8820"
					fill="#3f8ab4"
					d="M10.932-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8821"
					fill="#3f8ab4"
					d="M11.331-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8822"
					fill="#408bb4"
					d="M11.731-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8823"
					fill="#408bb4"
					d="M12.13-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8824"
					fill="#408cb3"
					d="M12.529-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8825"
					fill="#408cb3"
					d="M12.928-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8826"
					fill="#408cb3"
					d="M13.327-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8827"
					fill="#418db3"
					d="M13.726-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8828"
					fill="#418db3"
					d="M14.125-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8829"
					fill="#418eb3"
					d="M14.524-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8830"
					fill="#418eb3"
					d="M14.924-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8831"
					fill="#418fb3"
					d="M15.323-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8832"
					fill="#428fb2"
					d="M15.722-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8833"
					fill="#428fb2"
					d="M16.121-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8834"
					fill="#4290b2"
					d="M16.52-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8835"
					fill="#4290b2"
					d="M16.92-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8836"
					fill="#4391b2"
					d="M17.319-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8837"
					fill="#4391b2"
					d="M17.718-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8838"
					fill="#4391b2"
					d="M18.117-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8839"
					fill="#4392b1"
					d="M18.516-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8840"
					fill="#4492b1"
					d="M18.915-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8841"
					fill="#4493b1"
					d="M19.315-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8842"
					fill="#4493b1"
					d="M19.714-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8843"
					fill="#4493b1"
					d="M20.113-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8844"
					fill="#4494b1"
					d="M20.512-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8845"
					fill="#4594b0"
					d="M20.911-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8846"
					fill="#4595b0"
					d="M21.31-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8847"
					fill="#4595b0"
					d="M21.709-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8848"
					fill="#4695b0"
					d="M22.109-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8849"
					fill="#4696b0"
					d="M22.508-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8850"
					fill="#4696b0"
					d="M22.907-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8851"
					fill="#4697af"
					d="M23.306-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8852"
					fill="#4697af"
					d="M23.705-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8853"
					fill="#4797af"
					d="M24.105-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8854"
					fill="#4798af"
					d="M24.504-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8855"
					fill="#4798af"
					d="M24.903-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8856"
					fill="#4799ae"
					d="M25.302-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8857"
					fill="#4899ae"
					d="M25.701-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8858"
					fill="#489aae"
					d="M26.1-3.039h.399v52.918H26.1z"
				/>
				<path
					data-name="Rectangle 8859"
					fill="#489aae"
					d="M26.5-3.039h.399v52.918H26.5z"
				/>
				<path
					data-name="Rectangle 8860"
					fill="#489aae"
					d="M26.899-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8861"
					fill="#499bae"
					d="M27.298-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8862"
					fill="#499bad"
					d="M27.697-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8863"
					fill="#499bad"
					d="M28.096-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8864"
					fill="#499cad"
					d="M28.495-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8865"
					fill="#499cad"
					d="M28.894-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8866"
					fill="#4a9dad"
					d="M29.293-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8867"
					fill="#4a9dac"
					d="M29.693-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8868"
					fill="#4a9eac"
					d="M30.092-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8869"
					fill="#4a9eac"
					d="M30.491-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8870"
					fill="#4b9eac"
					d="M30.89-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8871"
					fill="#4b9fac"
					d="M31.29-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8872"
					fill="#4b9fab"
					d="M31.689-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8873"
					fill="#4ba0ab"
					d="M32.088-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8874"
					fill="#4ca0ab"
					d="M32.487-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8875"
					fill="#4ca0ab"
					d="M32.886-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8876"
					fill="#4ca1aa"
					d="M33.285-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8877"
					fill="#4ca1aa"
					d="M33.684-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8878"
					fill="#4ca2aa"
					d="M34.084-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8879"
					fill="#4da2aa"
					d="M34.483-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8880"
					fill="#4da2aa"
					d="M34.882-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8881"
					fill="#4da3a9"
					d="M35.281-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8882"
					fill="#4da3a9"
					d="M35.68-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8883"
					fill="#4ea4a9"
					d="M36.079-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8884"
					fill="#4ea4a9"
					d="M36.478-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8885"
					fill="#4ea4a8"
					d="M36.878-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8886"
					fill="#4ea5a8"
					d="M37.277-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8887"
					fill="#4fa5a8"
					d="M37.676-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8888"
					fill="#4fa6a8"
					d="M38.075-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8889"
					fill="#4fa6a8"
					d="M38.474-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8890"
					fill="#4fa6a7"
					d="M38.874-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8891"
					fill="#50a7a7"
					d="M39.273-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8892"
					fill="#50a7a7"
					d="M39.672-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8893"
					fill="#50a8a7"
					d="M40.071-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8894"
					fill="#50a8a6"
					d="M40.47-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8895"
					fill="#50a9a6"
					d="M40.869-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8896"
					fill="#51a9a6"
					d="M41.269-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8897"
					fill="#51a9a6"
					d="M41.668-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8898"
					fill="#51aaa5"
					d="M42.067-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8899"
					fill="#52aaa5"
					d="M42.466-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8900"
					fill="#52aba5"
					d="M42.865-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8901"
					fill="#52aba5"
					d="M43.264-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8902"
					fill="#52aba4"
					d="M43.663-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8903"
					fill="#53aca4"
					d="M44.063-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8904"
					fill="#53aca4"
					d="M44.462-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8905"
					fill="#53ada3"
					d="M44.861-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8906"
					fill="#53ada3"
					d="M45.26-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8907"
					fill="#54ada3"
					d="M45.659-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8908"
					fill="#54aea3"
					d="M46.059-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8909"
					fill="#54aea2"
					d="M46.458-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8910"
					fill="#54afa2"
					d="M46.857-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8911"
					fill="#55afa2"
					d="M47.256-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8912"
					fill="#55afa2"
					d="M47.655-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8913"
					fill="#55b0a1"
					d="M48.054-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8914"
					fill="#55b0a1"
					d="M48.453-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8915"
					fill="#56b1a1"
					d="M48.853-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8916"
					fill="#56b1a1"
					d="M49.252-3.039h.399v52.918h-.399z"
				/>
				<path
					data-name="Rectangle 8917"
					fill="#56b1a1"
					d="M49.651-3.039h9.634v52.918h-9.634z"
				/>
			</g>
		</g>
	</svg>
);

export const ClockIcon = ({ color = '#acadae' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="13.193"
		height="13.193"
		viewBox="0 0 13.193 13.193"
	>
		<g id="clock_15_" data-name="clock (15)" transform="translate(-1 -1)">
			<path
				id="Path_86168"
				data-name="Path 86168"
				d="M7.6,1a6.6,6.6,0,1,0,6.6,6.6A6.6,6.6,0,0,0,7.6,1Zm0,11.994a5.4,5.4,0,1,1,5.4-5.4A5.4,5.4,0,0,1,7.6,12.994Z"
				transform="translate(0)"
				fill={color}
			/>
			<path
				id="Path_86169"
				data-name="Path 86169"
				d="M12.2,8.95V5.6a.6.6,0,1,0-1.2,0V9.2a.6.6,0,0,0,.176.424l1.8,1.8a.6.6,0,1,0,.848-.848Z"
				transform="translate(-4.003 -1.601)"
				fill={color}
			/>
		</g>
	</svg>
);

export const ClockIconCustom = ({ color = '#B1B3B7' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		height="13"
		viewBox="0 -960 960 960"
		width="13"
	>
		<path
			d="m627-287 45-45-159-160v-201h-60v225l174 181ZM480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-82 31.5-155t86-127.5Q252-817 325-848.5T480-880q82 0 155 31.5t127.5 86Q817-708 848.5-635T880-480q0 82-31.5 155t-86 127.5Q708-143 635-111.5T480-80Z"
			fill={color}
		/>
	</svg>
);
